angular.module('keepalive', [])
    .provider('keepalive', function () {
        var options = {
            interval: 5,
            http: {
                method: "post",
                url: "/api/ping",
                timeout: 2000
            }
        };

        //keep link to interval function
        var state = {
            ping: null,
            lastPing: null,
            lastStandbyCheck: (new Date()).getTime(),
            version: null,
            lostpings: 0,
            running: false,
            applicationKey: ""
        };

        this.$get = ['$rootScope', '$log', '$interval', '$http',
            function ($rootScope, $log, $interval, $http) {
                $rootScope.$keepalive = state;
                function checkApplicationKey(newkey) {
                    if (!newkey) {
                        return false;
                    }
                    //initial load should not trigger reload
                    if (!state.applicationKey) {
                        state.applicationKey = newkey;
                        return true
                    }
                    if (newkey != state.applicationKey) {
                        return false
                    }
                    return true
                }

                function handleResponse(data, status) {
                    if (status == 200) {
                        state.lostpings = 0;
                        state.lastPing = new Date();
                        if (!state.running) {
                            state.running = true;
                            $rootScope.$broadcast('keepalive:ping-recover');
                        }
                        if (!checkApplicationKey(data.applicationKey)) {
                            state.applicationKey = data.applicationKey;
                            $rootScope.$broadcast('keepalive:reload-required');
                            location.reload(true);
                        }
                    } else {
                        //handle network connection errors or interruptions
                        state.lostpings = state.lostpings+1;
                        if(state.lostpings > 10) {
                            state.running = false;
                            $rootScope.$broadcast('keepalive:ping-error');
                        } else {
                            $log.info("ping problem raising"+state.lostpings);
                        }
                    }
                }

                //call ping service
                function pingAndCheckStandby() {
                    //detect standby
                    var currentTime = (new Date()).getTime();
                    if (currentTime > (state.lastStandbyCheck + options.interval * 5000)) {  // ignore small delays
                        location.reload(true);
                        return;
                    }
                    state.lastStandbyCheck = currentTime;
                    //detect failed ping
                    $http(options.http).success(handleResponse).error(handleResponse);
                }

                return {
                    _options: function () {
                        return options;
                    },
                    start: function () {
                        $interval.cancel(state.ping);
                        pingAndCheckStandby();
                        state.ping = $interval(pingAndCheckStandby, options.interval * 1000);
                        return state.ping;
                    },
                    stop: function () {
                        $interval.cancel(state.ping);
                    },
                    checkStandby: function () {
                        pingAndCheckStandby();
                    }
                }
            }];


    });



(function(){
    'use strict';

    // Key codes
    var keys = {
        enter : 13,
        esc   : 27,
        left  : 37,
        right : 39
    };

    angular
        .module('mod.ng-image-gallery', ['ngAnimate'])
        .provider('ngImageGalleryOpts', function(){
            var defOpts = {
                thumbnails  	:   true,
                thumbSize		: 	80,
                thumbLimit		: 	false,
                inline      	:   false,
                bubbles     	:   true,
                bubbleSize		: 	20,
                imgBubbles  	:   false,
                bgClose     	:   false,
                piracy 			: 	false,
                imgAnim 		: 	'fadeup',
                textValues: {
                    imageLoadErrorMsg       : 'Error when loading the image!',
                    deleteButtonTitle       : 'Delete this image...',
                    editButtonTitle         : 'Edit this image...',
                    closeButtonTitle        : 'Close',
                    externalLinkButtonTitle : 'Open image in new tab...'
                }
            };

            return{
                setOpts : function(newOpts){
                    angular.extend(defOpts, newOpts);
                },
                $get : function(){
                    return defOpts;
                }
            }
        })
        .filter('ngImageGalleryTrust', ['$sce', function($sce) {
            return function(value, type) {
                // Defaults to treating trusted value as `html`
                return $sce.trustAs(type || 'html', value);
            }
        }])
        .directive('ngRightClick', ['$parse', function($parse){
            return {
                restrict: "A",
                scope : false,
                link : function(scope, element, attrs){
                    element.bind('contextmenu', function(event){
                        if(scope.piracy == false){
                            event.preventDefault();
                            return scope.piracy;
                        }
                    });
                }
            };
        }])
        .directive("showImageAsync", [function(){
            return {
                restrict: "A",
                scope: false,
                link: function (scope, element, attributes){
                    var image = new Image();
                    image.src = attributes.showImageAsync;
                    image.onload = function(){
                        scope.$apply(function(){
                            if(attributes.asyncKind == 'thumb'){
                                element.css({ backgroundImage: 'url("' + attributes.showImageAsync + '")' });
                                element.empty(); // remove loading animation element
                            }
                            else if(attributes.asyncKind == 'bubble'){
                                element.css({ backgroundImage: 'url("' + attributes.showImageAsync + '")' });
                            }
                        });
                    };
                    image.onerror = function(){
                        element.empty(); // remove loading animation element
                    }
                }
            };
        }])
        .directive("bubbleAutoFit", ['$window', '$timeout', function($window, $timeout){
            return {
                restrict: "A",
                scope: false,
                link: {
                    pre : function (scope, element, attributes){
                        var autoFitBubbles = function(){
                            var scrollerWidth = element[0].getBoundingClientRect().width;
                            if(scrollerWidth == 0) return;

                            var bubbleSize = scope.bubbleSize;
                            var minMargin = 4 + 4; // left+right
                            var bubbleSpace = (bubbleSize + minMargin);
                            var rawQuotient = scrollerWidth / bubbleSpace;
                            var bubblesInView = Math.floor(rawQuotient);
                            var extraSpace = scrollerWidth - (bubblesInView * bubbleSpace);
                            var extraMargin = extraSpace / bubblesInView;
                            var bubbleMargin = minMargin + extraMargin;
                            var finalBubbleSpace = bubbleMargin + bubbleSize;

                            scope._bubblesInView = bubblesInView;
                            scope._finalBubbleSpace = finalBubbleSpace;
                            scope._bubbleMargin = '0 ' + (bubbleMargin/2) + 'px';

                            scope._safeApply(angular.noop);
                        };

                        $timeout(autoFitBubbles);

                        angular.element($window).bind('resize', function(){
                            $timeout(autoFitBubbles);
                        });
                        scope.$watch('inline', function(){
                            $timeout(autoFitBubbles);
                        });
                        scope.$watch('bubbleSize', function(){
                            $timeout(autoFitBubbles);
                        });
                        scope.$watchCollection('images', function(){
                            $timeout(autoFitBubbles);
                        });
                    }
                }
            };
        }])
        .directive("bubbleAutoScroll", ['$window', '$timeout', function($window, $timeout){
            return {
                restrict: "A",
                scope: false,
                link: function (scope, element, attributes){

                    var indexCalc = function(){
                        var relativeIndexToBubbleWrapper = scope._bubblesInView - (scope._bubblesInView - scope._activeImageIndex);

                        $timeout(function(){
                            if(relativeIndexToBubbleWrapper > scope._bubblesInView - 2){
                                var outBubbles = ((scope._activeImageIndex+1) - scope._bubblesInView) + 1;

                                if(scope._activeImageIndex != (scope.images.length - 1)){
                                    scope._bubblesContainerMarginLeft = '-' + (scope._finalBubbleSpace * outBubbles) + 'px';
                                }
                                else{
                                    scope._bubblesContainerMarginLeft = '-' + (scope._finalBubbleSpace * (outBubbles - 1)) + 'px';
                                }
                            }
                            else{
                                scope._bubblesContainerMarginLeft = '0px';
                            }
                        });
                    }

                    angular.element($window).bind('resize', function(){
                        $timeout(indexCalc);
                    });
                    scope.$watch('_bubblesInView', function(){
                        $timeout(indexCalc);
                    });
                    scope.$watch('_activeImageIndex', function(){
                        $timeout(indexCalc);
                    });
                    scope.$watchCollection('images', function(){
                        $timeout(indexCalc);
                    });
                }
            };
        }])
        .directive('ngImageGallery', ['$rootScope', '$timeout', '$q', 'ngImageGalleryOpts','$translate',
            function($rootScope, $timeout, $q, ngImageGalleryOpts, $translate){
                return {
                    replace : true,
                    transclude : false,
                    restrict : 'AE',
                    scope : {
                        images 			: 	'=',		// []
                        methods 		: 	'=?',		// {}
                        conf 			: 	'=?',		// {}

                        thumbnails 		: 	'=?',		// true|false
                        thumbSize		: 	'=?', 		// px
                        thumbLimit		: 	'=?', 		// px
                        inline 			: 	'=?',		// true|false
                        bubbles 		: 	'=?',		// true|false
                        bubbleSize 		: 	'=?',		// px
                        imgBubbles 		: 	'=?',		// true|false
                        bgClose 		: 	'=?',		// true|false
                        piracy			: 	'=?',		// true|false
                        imgAnim 		: 	'@?',		// {name}
                        textValues      :   '=?',		// {}
                        startImage      :   '=',        //the id of the image to show after loading
                        onPurchase      :   '&',

                    },
                    templateUrl : 'app/components/gallery/gallery.html'	,

                    link : {
                        pre : function(scope, elem, attr){
                            var txt = $translate.instant("SELFCHECKIN_WATERMARK_TEXT")
                            if (txt && "SELFCHECKIN_WATERMARK_TEXT"!= txt) {
                                scope.watermark = txt;
                            } else {
                                scope.watermark = ""
                            }

                            /*
                             *	Operational functions
                            **/

                            // Show gallery loader
                            scope._showLoader = function(){
                                scope.imgLoading = true;
                            }

                            // Hide gallery loader
                            scope._hideLoader = function(){
                                scope.imgLoading = false;
                            }

                            // Image load complete promise
                            scope._loadImg = function(imgObj){

                                // Return rejected promise
                                // if not image object received
                                if(!imgObj) return $q.reject();

                                var deferred =  $q.defer();

                                // Show loader
                                if(!imgObj.hasOwnProperty('cached')) scope._showLoader();

                                // Process image
                                var img = new Image();
                                img.src = imgObj.url;
                                img.onload = function(){
                                    // Hide loader
                                    if(!imgObj.hasOwnProperty('cached')) scope._hideLoader();

                                    // Cache image
                                    if(!imgObj.hasOwnProperty('cached')) imgObj.cached = true;

                                    deferred.resolve(imgObj);
                                }
                                img.onerror = function(){
                                    if(!imgObj.hasOwnProperty('cached')) scope._hideLoader();

                                    deferred.reject('Error when loading img');
                                }

                                return deferred.promise;
                            }

                            scope._setActiveImg = function(imgObj){
                                // Get images move direction
                                if(
                                    scope.images.indexOf(scope._activeImg) - scope.images.indexOf(imgObj) == (scope.images.length - 1) ||
                                    (
                                        scope.images.indexOf(scope._activeImg) - scope.images.indexOf(imgObj) <= 0 &&
                                        scope.images.indexOf(scope._activeImg) - scope.images.indexOf(imgObj) != -(scope.images.length - 1)
                                    )

                                ){
                                    scope._imgMoveDirection = 'forward';
                                }
                                else{
                                    scope._imgMoveDirection = 'backward';
                                }

                                // Load image
                                scope._loadImg(imgObj).then(function(imgObj){
                                    scope._activeImg = imgObj;
                                    scope._activeImageIndex = scope.images.indexOf(imgObj);
                                    scope.imgError = false;
                                }, function(){
                                    scope._activeImg = null;
                                    scope._activeImageIndex = scope.images.indexOf(imgObj);
                                    scope.imgError = true;
                                })
                                ;
                            }

                            scope._safeApply = function(fn){
                                var phase = this.$root.$$phase;
                                if(phase == '$apply' || phase == '$digest'){
                                    if(fn && (typeof(fn) === 'function')){
                                        fn();
                                    }
                                }else{
                                    this.$apply(fn);
                                }
                            };

                            //pass purchase event to controller
                            scope._pruchaseImg = function (img) {
                                scope.onPurchase({photo:img});
                            }


                            /*
                             *	Gallery settings
                            **/

                            // Modify scope models
                            scope.images 	 	 = 	(scope.images 		!= undefined) ? scope.images 	 : 	[];
                            scope.methods 	 	 = 	(scope.methods 		!= undefined) ? scope.methods 	 : 	{};
                            scope.conf 	 		 = 	(scope.conf 		!= undefined) ? scope.conf 		 : 	{};

                            // setting options
                            scope.$watchCollection('conf', function(conf){
                                scope.thumbnails 	 = 	(conf.thumbnails 	!= undefined) ? conf.thumbnails 	: 	(scope.thumbnails 	!= undefined) 	?  scope.thumbnails		: 	ngImageGalleryOpts.thumbnails;
                                scope.thumbSize 	 = 	(conf.thumbSize 	!= undefined) ? conf.thumbSize 		: 	(scope.thumbSize 	!= undefined) 	?  scope.thumbSize		: 	ngImageGalleryOpts.thumbSize;
                                scope.thumbLimit 	 = 	(conf.thumbLimit 	!= undefined) ? conf.thumbLimit 		: 	(scope.thumbLimit	!= undefined) 	?  scope.thumbLimit		: 	ngImageGalleryOpts.thumbLimit;
                                scope.inline 	 	 = 	(conf.inline 		!= undefined) ? conf.inline 	 	: 	(scope.inline 		!= undefined) 	?  scope.inline			: 	ngImageGalleryOpts.inline;
                                scope.bubbles 	 	 = 	(conf.bubbles 		!= undefined) ? conf.bubbles 	 	: 	(scope.bubbles 		!= undefined) 	?  scope.bubbles		: 	ngImageGalleryOpts.bubbles;
                                scope.bubbleSize 	 = 	(conf.bubbleSize 	!= undefined) ? conf.bubbleSize 	 : 	(scope.bubbleSize 	!= undefined) 	?  scope.bubbleSize		: 	ngImageGalleryOpts.bubbleSize;
                                scope.imgBubbles 	 = 	(conf.imgBubbles 	!= undefined) ? conf.imgBubbles 	: 	(scope.imgBubbles 	!= undefined) 	?  scope.imgBubbles		: 	ngImageGalleryOpts.imgBubbles;
                                scope.bgClose 	 	 = 	(conf.bgClose 		!= undefined) ? conf.bgClose 	 	: 	(scope.bgClose 		!= undefined) 	?  scope.bgClose		: 	ngImageGalleryOpts.bgClose;
                                scope.piracy 	 	 = 	(conf.piracy 		!= undefined) ? conf.piracy 	 	: 	(scope.piracy 		!= undefined) 	?  scope.piracy			: 	ngImageGalleryOpts.piracy;
                                scope.imgAnim 	 	 = 	(conf.imgAnim 		!= undefined) ? conf.imgAnim 	 	: 	(scope.imgAnim 		!= undefined) 	?  scope.imgAnim		: 	ngImageGalleryOpts.imgAnim;
                                scope.textValues     =  (conf.textValues    != undefined) ? conf.textValues     :   (scope.textValues   != undefined)   ?  scope.textValues     :   ngImageGalleryOpts.textValues;
                            });

                            scope.onOpen 	 = 	(scope.onOpen 	!= undefined) ? scope.onOpen 	 : 	angular.noop;
                            scope.onClose 	 = 	(scope.onClose 	!= undefined) ? scope.onClose 	 : 	angular.noop;
                            scope.onPurchase = (scope.onPurchase != undefined) ? scope.onPurchase : angular.noop;

                            // If images populate dynamically, reset gallery
                            var imagesFirstWatch = true;
                            scope.$watchCollection('images', function(){
                                if(imagesFirstWatch){
                                    imagesFirstWatch = false;
                                }
                                else if(scope.images.length){
                                    scope._setActiveImg(scope.images[scope._activeImageIndex || 0]);
                                }
                            });

                            // Watch index of visible/active image
                            // If index changes, make sure to load/change image
                            var activeImageIndexFirstWatch = true;
                            scope.$watch('_activeImageIndex', function(newImgIndex){
                                if(activeImageIndexFirstWatch){
                                    activeImageIndexFirstWatch = false;
                                }
                                else if(scope.images.length){
                                    scope._setActiveImg(scope.images[newImgIndex]);
                                }
                            });

                            // Open modal automatically if inline
                            scope.$watch('inline', function(){
                                $timeout(function(){
                                    if(scope.inline) {
                                        var _startIndex = 0;
                                        //open after everything was loaded. set start image by offset.
                                        if (scope.startImage) {
                                            var startImage = _.find(scope.images, function (image) {
                                                return image.id == scope.startImage;
                                            })
                                            var _startIndex = _.findIndex(scope.images, startImage) || 0
                                        }

                                        scope.methods.open(_startIndex);
                                    }
                                });
                            });


                            /***************************************************/


                            /*
                             *	Methods
                            **/

                            // Open gallery modal
                            scope.methods.open = function(imgIndex){
                                // Open modal from an index if one passed
                                scope._activeImageIndex = (imgIndex) ? imgIndex : 0;

                                scope.opened = true;

                                // set overflow hidden to body
                                if(!scope.inline) angular.element(document.body).addClass('body-overflow-hidden');

                                // call open event after transition
                                $timeout(function(){
                                    scope.onOpen();
                                }, 300);
                            }

                            // Close gallery modal
                            scope.methods.close = function(){
                                scope.opened = false; // Model closed

                                // set overflow hidden to body
                                angular.element(document.body).removeClass('body-overflow-hidden');

                                // call close event after transition
                                $timeout(function(){
                                    scope.onClose();
                                    scope._activeImageIndex = 0; // Reset index
                                }, 300);
                            }

                            // Change image to next
                            scope.methods.next = function(){
                                if(scope._activeImageIndex == (scope.images.length - 1)){
                                    scope._activeImageIndex = 0;
                                }
                                else{
                                    scope._activeImageIndex = scope._activeImageIndex + 1;
                                }
                            }

                            // Change image to prev
                            scope.methods.prev = function(){
                                if(scope._activeImageIndex == 0){
                                    scope._activeImageIndex = scope.images.length - 1;
                                }
                                else{
                                    scope._activeImageIndex--;
                                }
                            }

                            // Close gallery on background click
                            scope.backgroundClose = function(e){
                                if(!scope.bgClose || scope.inline) return;

                                var noCloseClasses = [
                                    'galleria-image',
                                    'destroy-icons-container',
                                    'ext-url',
                                    'close',
                                    'next',
                                    'prev',
                                    'galleria-bubble'
                                ];

                                // check if clicked element has a class that
                                // belongs to `noCloseClasses`
                                for(var i = 0; i < e.target.classList.length; i++){
                                    if(noCloseClasses.indexOf(e.target.classList[i]) != -1){
                                        break;
                                    }
                                    else{
                                        scope.methods.close();
                                    }
                                }
                            }


                            /***************************************************/


                            /*
                             *	User interactions
                            **/

                            // Key events
                            angular.element(document).bind('keyup', function(event){
                                // If inline modal, do not interact
                                if(scope.inline) return;

                                if(event.which == keys.right || event.which == keys.enter){
                                    $timeout(function(){
                                        scope.methods.next();
                                    });
                                }
                                else if(event.which == keys.left){
                                    $timeout(function(){
                                        scope.methods.prev();
                                    });
                                }
                                else if(event.which == keys.esc){
                                    $timeout(function(){
                                        scope.methods.close();
                                    });
                                }
                            });

                            // Swipe events
                            if(window.Hammer){
                                var hammerElem = new Hammer(elem[0]);
                                hammerElem.on('swiperight', function(ev){
                                    $timeout(function(){
                                        scope.methods.prev();
                                    });
                                });
                                hammerElem.on('swipeleft', function(ev){
                                    $timeout(function(){
                                        scope.methods.next();
                                    });
                                });
                                hammerElem.on('doubletap', function(ev){
                                    if(scope.inline) return;

                                    $timeout(function(){
                                        scope.methods.close();
                                    });
                                });
                            };


                            /***********************************************************/


                            /*
                             *	Actions on angular events
                            **/

                            var removeClassFromDocumentBody = function(){
                                angular.element(document.body).removeClass('body-overflow-hidden');
                            };

                            $rootScope.$on('$stateChangeSuccess', removeClassFromDocumentBody);
                            $rootScope.$on('$routeChangeSuccess', removeClassFromDocumentBody);

                        }
                    }
                }
            }]);
})();
/**
 * AngularJS 1.5+ Component using moment for Birthday input component
 * params: {
 *   String:returnType: if 'moment', return a moment object, Javascript Date instead. default: Javascript
 *   String:returnFormat: force a return type string with the given format (see momentjs code to see how)
 *   Boolean:askDay: Display the day input. default: true
 *   {returnType}:ngModel: One way binding returning the selected date
 * }
 */

'use strict';

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

// var BirthdayInputComponent = function ($scope, $locale) {
//     function BirthdayInputComponent() {
//         _classCallCheck(this, BirthdayInputComponent);
//     }
//
//     _createClass(BirthdayInputComponent, [{
//         key: '$onInit',
//         value: function $onInit($locale) {
//             this.years = this.getLastYears();
//             console.log("scope", $scope);
//             console.log("translate", $locale);
//             var formatter = new Intl.DateTimeFormat('de', {month: 'long'}); // Change 'fr' for locale
//             var monthNames = Array.from({length: 12}, (_, i) =>
//                 formatter.format(new Date(2023, i, 1))
//             );
//
//             this.months = monthNames; // moment.months();
//             console.log("Month", this.months);
//             this.askDay = angular.isUndefined(this.askDay) || this.askDay;
//             this.initToday = Boolean(this.initToday);
//
//             this.ngModel = this.ngModel && moment(this.ngModel) || this.initToday && moment(new Date()) || undefined;
//
//             if (this.ngModel) {
//                 var year = this.ngModel.year();
//                 var month = this.ngModel.month();
//                 var nbDays = moment(year + month, 'YYYYMM').daysInMonth();
//                 this.days = this.range(nbDays);
//
//                 this.year = year;
//                 this.month = String(this.ngModel.month());
//                 this.day = parseInt(this.ngModel.format('DD'), 0);
//             }
//         }
//     }, {
//         key: 'update',
//         value: function update() {
//
//             var year = this.year && String(this.year);
//             var month = this.month && String(Number(this.month) + 1);
//             var day = this.day && String(this.day);
//
//             if (year && month && (day || !this.askDay)) {
//                 var birthdayDate = moment(year + "-" + month + "-" + day, 'YYYY-MM-DD');
//                 if (this.returnFormat) {
//                     this.ngModel = birthdayDate.format(this.returnFormat);
//                 } else {
//                     this.ngModel = this.returnType === 'moment' ? birthdayDate : birthdayDate.toDate();
//                 }
//             } else if (this.year && this.month) {
//                 var nbDays = moment(year + month, 'YYYYMM').daysInMonth();
//                 this.days = this.range(nbDays);
//                 this.ngModel = undefined;
//             } else {
//                 this.ngModel = undefined;
//                 this.days = [];
//             }
//         }
//     }, {
//         key: 'range',
//         value: function range(many) {
//             return Array.apply(null, Array(many)).map(function (_, i) {
//                 return ++i;
//             });
//         }
//     }, {
//         key: 'getLastYears',
//         value: function getLastYears() {
//             var years = [];
//             var currentYear = moment().year();
//             for (var i = 0; i < 130; i++) {
//                 years.push(currentYear--);
//             }
//             return years;
//         }
//     }]);
//
//     return BirthdayInputComponent;
// }();

angular.module('angularjs-input-birthday', [
    'pascalprecht.translate'
])
    .component('inputBirthday', {
        templateUrl: 'app/components/birthday/input-birthday.template.html',
        bindings: {
            returnType: '@',
            returnFormat: '@',
            initToday: '<',
            askDay: '<',
            ngModel: '=',
            yearLabel: '<',
            monthLabel: '<'
        },

        controller: function ($scope, $locale, $translate) {
            var ctrl = this;
            ctrl.$onInit = function () {
                ctrl.years = this.getLastYears();
                var formatter = new Intl.DateTimeFormat($translate.use(), {month: 'long'}); // Change 'fr' for locale
                var monthNames = [];
                for (var i = 0; i < 12; i++) {
                    var date = new Date(2025, i, 1);
                    monthNames.push(formatter.format(date));
                }

                ctrl.months = monthNames; // moment.months();
                ctrl.askDay = angular.isUndefined(ctrl.askDay) || ctrl.askDay;
                ctrl.initToday = Boolean(ctrl.initToday);

                ctrl.ngModel = ctrl.ngModel && moment(ctrl.ngModel) || ctrl.initToday && moment(new Date()) || undefined;

                if (ctrl.ngModel) {
                    var year = ctrl.ngModel.year();
                    var month = ctrl.ngModel.month();
                    var nbDays = moment(year + month, 'YYYYMM').daysInMonth();
                    ctrl.days = ctrl.range(nbDays);

                    ctrl.year = year;
                    ctrl.month = String(ctrl.ngModel.month());
                    ctrl.day = parseInt(ctrl.ngModel.format('DD'), 0);
                }
            }
            ctrl.update = function () {
                var year = ctrl.year && String(ctrl.year);
                var month = ctrl.month && String(Number(ctrl.month) + 1);
                var day = ctrl.day && String(ctrl.day);

                if (year && month && (day || !ctrl.askDay)) {
                    var birthdayDate = moment(year + "-" + month + "-" + day, 'YYYY-MM-DD');
                    if (ctrl.returnFormat) {
                        ctrl.ngModel = birthdayDate.format(ctrl.returnFormat);
                    } else {
                        ctrl.ngModel = ctrl.returnType === 'moment' ? birthdayDate : birthdayDate.toDate();
                    }
                } else if (ctrl.year && ctrl.month) {
                    var nbDays = moment(year + month, 'YYYYMM').daysInMonth();
                    ctrl.days = ctrl.range(nbDays);
                    ctrl.ngModel = undefined;
                } else {
                    ctrl.ngModel = undefined;
                    ctrl.days = [];
                }
            }
            ctrl.range = function (many) {
                return Array.apply(null, Array(many)).map(function (_, i) {
                    return ++i;
                });
            }
            ctrl.getLastYears = function () {
                var years = [];
                var currentYear = moment().year();
                for (var i = 0; i < 130; i++) {
                    years.push(currentYear--);
                }
                return years;
            }
        }
    });



(function () {
    'use strict';

    angular
        .module('selfservice',['ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages', 'ui.router',
            'angularMoment',
            'globalDirectives',
            'keepalive',
            'ngSanitize',
            'formly', 'formlyBootstrap',
            'ui.bootstrap',
            'mgo-angular-wizard',
            'angular-spinkit',
            'pascalprecht.translate',
            'puigcerber.countryPicker',
            'partnermarketing.matchHeight',
            'ngIdle',
            'fancyboxplus','afkl.lazyImage',
            'dialogs.main',
            'ngLoadingSpinner',
            'mod.ng-image-gallery',
            'angularjs-input-birthday'// for photo slider
            //'keepalive', 'authService', 'ng-token-auth','booking.auth'
        ]);

})();

angular
    .module('selfservice')
    .factory('waiverService', waiverService)


/** @ngInject */
function waiverService($rootScope, $q, $http, $translate) {
    var waiver;
    var invite;
    var waiverModel;
    var allowInlineSignature;
    var language;
    var securitykey;

    $rootScope.$on('$translateChangeEnd', function () {
        if (waiver) {
            //reload waiver because translation changed. Values stay in place
            loadWaiver(securitykey)
        }
    })

    // function updateFormlyFields(step) {
    //     if (!step) {
    //         return
    //     }
    //     angular.forEach(step.form.fields, function (field) {
    //        console.log(step);
    //         field.runExpressions && field.runExpressions();
    //     });
    // }

    function loadWaiver(_securitykey) {
        var currentLang = $translate.proposedLanguage() || $translate.use();
        var deferred = $q.defer();
        if (waiver && language === currentLang) {
            deferred.resolve(waiver);
        } else {
            $http.get('/waver/' + _securitykey + "?lang=" + currentLang).then(function (success) {
                securitykey = _securitykey;
                language = currentLang
                waiver = success.data.form;
                waiverModel = success.data.model;
                allowInlineSignature = success.data.allowInlineSignature;
                deferred.resolve(waiver);
            }, function (error) {
                deferred.reject(error);
            });
        }
        return deferred.promise;
    }

    return {
        //load from server
        getWaiver: function() {return waiver},
        getModel: function() {return waiverModel},
        getAllowInlineSignature: function() {
            return allowInlineSignature
        },
        loadWaiver: loadWaiver,
        signWaiver: function (signature) {
            var deferred = $q.defer();
            waiverModel.signature = signature;
            $http.post('/waver/' + waiverModel.securitykey, waiverModel).then(function (success) {
                deferred.resolve(success.data);
            }, function (error) {
                console.log("error");
            });
            return deferred.promise;
        },
        saveWaiver: function (securitykey, formdata) {
            var deferred = $q.defer();
            $http.post('/waver/' + securitykey, formdata).then(function (success) {
                deferred.resolve(success.data);
            }, function (error) {
                console.log("error");
            });
            return deferred.promise;
        },

        loadInvite: function(securitykey) {
            var deferred = $q.defer();
            $http.get('/waver/invite/'+securitykey).then(function (success) {
                invite = success.data;
                deferred.resolve(invite);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
        confirmInvite: function(securitykey, confirmType) {
            var deferred = $q.defer();
            $http.post('/waver/invite/'+securitykey+'?confirmType='+confirmType).then(function (success) {
                waiver = success.data.form;
                waiverModel = success.data.model;
                allowInlineSignature = success.data.allowInlineSignature;
                deferred.resolve(invite);
            }, function (error) {
                console.log("error");
            });
            return deferred.promise;
        },
        onlineReservationInvite : function(waiverId, id) {
            var deferred = $q.defer();
            $http.get('/waver/onlineReservationInvite/'+id+"?waverId="+waiverId).then(function (success) {
                deferred.resolve(success.data);
            }, function (error) {
                console.log("error");
            });
            return deferred.promise;
        },
        blankInvite : function(waiverId) {
            var deferred = $q.defer();
            $http.get('/waver/blankInvite?waverId='+waiverId).then(function (success) {
                waiver = success.data.form;
                waiverModel = success.data.model;
                allowInlineSignature = success.data.allowInlineSignature;
                deferred.resolve(success.data);
            }, function (error) {
                console.log("error");
            });
            return deferred.promise;
        },
        qrInvite : function(waiverId, accesscode) {
            var deferred = $q.defer();
            $http.get('/waver/blankInvite?waverId='+waiverId+'&t=qr&a='+accesscode).then(function (success) {
                waiver = success.data.form;
                waiverModel = success.data.model;
                allowInlineSignature = success.data.allowInlineSignature;
                deferred.resolve(success.data);
            }, function (error) {
                console.log("error");
            });
            return deferred.promise;
        },
        resetForm: function() {
            waiver = undefined;
            invite = undefined;
            waiverModel = undefined;
        }
    };
}
;


(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('WaiverSignatureController', WaiverSignatureController)
        .controller('WaiverController', WaiverController)
        .controller('WaiverStartController', WaiverStartController)
        .controller('WaiverInviteController', WaiverInviteController)
        .controller('WaiverConfirmController', WaiverConfirmController)

    /** @ngInject */
    function WaiverSignatureController($timeout, $q, $http, $state, $stateParams, $scope, waiverService, $translate, formData, formModel, Idle) {
        var vm = this;
        vm.fields = formData;
        vm.model = formModel;
        vm.signature = undefined;
        vm.signature2 = undefined;
        vm.signatureSaveBusy = false
        $scope.$watch(function () {
            return vm.signature2;
        }, function (value) {
            if (value) {
                vm.signatureSaveBusy = true;
                waiverService.signWaiver(value).then(function (success) {
                    vm.signatureSaveBusy = false;
                    if (success.status == 'OK') {
                        $state.go('confirmwaiver')
                    }
                }, function (error) {
                    vm.signatureSaveBusy = false;
                    console.log(error);
                })
            }

        });
    }

    /** @ngInject */
    function WaiverController($timeout, $q, $http, $state, $stateParams, $scope, $rootScope, waiverService, $translate, formData, formModel, Idle, WizardHandler) {
        var vm = this;
        Idle.watch();
        vm.finishWizard = finishWizard;
        // vm.test = test;
        vm.fields = formData;
        vm.model = formModel;
        vm.options = {watchAllExpressions: true};
        vm.showStep2;
        vm.showStep3;
        vm.showStep4;
        vm.showStep5;
        vm.showStep6;
        var allowInlineSignature = waiverService.getAllowInlineSignature()
        //monitor language selection changes
        updateStepVisibility();

        $rootScope.$on('$translateChangeEnd', function () {
            //timout for model update - otherwhise update after the second click
            $timeout(function () {
                vm.fields = waiverService.getWaiver();
                updateStepVisibility()
            }, 200)
        })

        $scope.$watch(waiverService.activeWaiver, function (newWaiver, oldWaiver) {
            vm.fields = waiverService.getWaiver();
            vm.model = waiverService.getModel();
        });

        function updateStepVisibility() {
            vm.showStep3 = vm.fields.step3 && vm.fields.step3.form.length>0;
            vm.showStep4 = vm.fields.step4 && vm.fields.step4.form.length>0;
            vm.showStep5 = vm.fields.step5 && vm.fields.step5.form.length>0;
            vm.showStep6 = vm.fields.step6 && vm.fields.step6.form.length>0;
        }

        // $rootScope.$on('$translateChangeEnd', function () {
        //     vm.fields = waiverService.getWaiver();
        //     console.log("shit");
        // })

        vm.exitValidation = function (form) {
            return form && !form.$invalid;
        };

        // function test() {
        //     $state.go('waiversignature', {securitykey: waiverService.getModel().securitykey});
        // }

        vm.nextStep = function(form) {

            if (form.$valid) {
                WizardHandler.wizard().next()
                console.log("Form submitted successfully!");
            } else {
                console.log("Please fill in all required fields correctly.");
                angular.forEach(form.$error, function(fields) {
                    angular.forEach(fields, function(field) {
                        field.$setTouched(); // Mark fields as touched to show errors
                    });
                });
            }

        }

        // function definition
        function finishWizard() {
            waiverService.saveWaiver($stateParams.securitykey, vm.model).then(function (success) {
                if (allowInlineSignature) {
                    $state.go('waiversignature', {securitykey: waiverService.getModel().securitykey});
                } else {
                    $state.go('confirmwaiver');
                }
            }, function (error) {
                console.log(error);
            })
        }
    }

    /** @ngInject */
    function WaiverInviteController($timeout, $q, $http, $state, $stateParams, $scope, formlyVersion, waiverService, $translate, Idle) {
        var vm = this;
        Idle.watch();
        waiverService.loadInvite($stateParams.key).then(function (data) {
            vm.invite = data;
        });

        vm.confirmInvite = confirmInvite;

        function confirmInvite(confirmType) {
            waiverService.confirmInvite($stateParams.key, confirmType).then(function (data) {
                $state.go('waiver', {securitykey: waiverService.getModel().securitykey})
            });
        }
    }

    /** @ngInject */
    function WaiverConfirmController($timeout, $q, $http, $state, waiverService, setupService) {
        //show back button only if a local security object exists
        var vm = this;
        vm.checkinActive = setupService.getCheckin()
        waiverService.resetForm();
    }

    /** @ngInject */
    function WaiverStartController($timeout, $q, $http, $state, $stateParams, waiverService, Idle) {
        var vm = this;
        Idle.watch();
        var waiverId = $stateParams.id
        vm.blankInvite = function () {
            waiverService.blankInvite(waiverId).then(function (data) {
                $state.go('waiver', {securitykey: data.securitykey})
            });
        }

        vm.selectReservationId = function () {
            waiverService.onlineReservationInvite(waiverId, vm.reservationId).then(function (data) {
                $state.go('invite', {key: data.securitykey})
            });
        }

    }


})
();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .provider('signature', signature)
        .directive('mrSignaturePad', mrSignaturePadDirective)

    /** @ngInject */
    function mrSignaturePadDirective($window, signature, $parse) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: "app/waiver/signaturePad.html",
            transclude: true,
            scope: {
                signatureData: '=',
                completeFn: '&',
                close: '&',
                options: '=',
            },
            require: 'ngModel',
            link: function (scope, $element, attrs, ctrl) {
                var canvas = $element.find('canvas'), signaturePad;
                scope.validsignature = false;
                signaturePad = new signature(canvas, scope, {
                    width: attrs.width,
                    height: attrs.height,
                    onEnd: function () {
                        if (signaturePad.isEmpty()) {
                            scope.validsignature = false;
                        } else {
                            scope.validsignature = true;
                        }
                        //scope.save();
                        //console.log(scope.$parent.result);
                    }
                });
                scope.save = function () {
                    var dataUrl;
                    if (signaturePad.isEmpty()) {
                        dataUrl = signaturePad.EMPTY_IMAGE;
                    } else {
                        dataUrl = signaturePad.toDataURL();
                        scope.signatureData = dataUrl;
                    }
                };

                scope.clear = function () {
                    signaturePad.clear();
                };
            }
        };
    };

    /** @ngInject */
    function signature() {
        return {
            $get : function ($window) {
                var signatureFactory = function (canvas, scope, options) {
                    var signaturePad,
                        EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';

                    signaturePad = new SignaturePad(canvas[0], {
                        onEnd: options.onEnd
                    });
                    setHeightAndWidth();

                    function setHeightAndWidth(width, height) {
                        var width = options.width;
                        var height = options.height;
                        canvas.attr('width', caculateWidth(width));
                        canvas.attr('height', caculateHeight(height));
                        // workarround for disabled
                    }

                    function parseVal(val) {
                        var parentWidth = canvas.parent()[0].clientWidth;
                        var isPercentage = !!val && (val.indexOf('%') > -1 || val.indexOf('/') > -1)
                        if (isPercentage) {
                            if (val.indexOf('%') > -1) {
                                return (val.split('%')[0] / 100) * parentWidth;
                            }
                            if (val.indexOf('/') > -1) {
                                var newVal = val.split('/');
                                return (newVal[0] / newVal[1]) * parentWidth;
                            }
                        }
                        return val;
                    }

                    function caculateWidth(width) {
                        return !!width ? parseVal(width) : canvas.parent()[0].clientWidth;
                    }

                    function caculateHeight(height) {
                        return !!height ? parseVal(height) : canvas.parent()[0].clientHeight;
                    }

                    $window.addEventListener('resize', function () {
                        scope.$apply(function () {
                            setHeightAndWidth();
                            // workarround for disabled
                        });
                    }, false);
                    $window.addEventListener('orientationchange', function () {
                        scope.$apply(function () {
                            setHeightAndWidth();
                            // workarround for disabled
                        });
                    }, false);

                    return {
                        EMPTY_IMAGE: 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=',
                        fromDataURL: function (dataUrl) {
                            signaturePad.fromDataURL(dataUrl);
                        },
                        toDataURL: function () {
                            return signaturePad.toDataURL();
                        },
                        clear: function () {
                            signaturePad.clear.call(signaturePad);
                        },
                        isEmpty: function () {
                            return signaturePad.isEmpty();
                        }
                    }
                }
                return signatureFactory;
            }
        }

    }
}());

angular
    .module('selfservice')
    .factory('setupService', setupService)

/** @ngInject */
function setupService($rootScope, $q, $http, $translate, $cookies) {
    var primitiveauth;
    var photo;
    var checkin;
    //list of ids of enabled activities. Activity details will be loaded on the first page of the selfcheckin
    var activities;
    var expireDate = new Date();
    expireDate.setTime(2144232732000);

    setupData();

    function setupData() {
        this.primitiveauth = $cookies.get("primitiveauth");

        var photoCookie = $cookies.get("photo");
        this.photo = ("true" == photoCookie || "True" == photoCookie)

        var checkinCookie = $cookies.get("checkin");
        this.checkin = ("true" == checkinCookie || "True" == checkinCookie)

        var activityCookie = $cookies.get("activities");
        if (activityCookie) {
            this.activities = JSON.parse(activityCookie);
        } else {
            this.activities = [1]
        }
    }

    /**
     * test the primitive auth key and return the possible activities for a preselection on the client
     */
    function retreiveActivities(apikey) {
        var deferred = $q.defer();
        //add temp authentification
        $http.get('/apikey/photoBoth/setup').then(function (resp) {
            // this.activities.splice(0, this.activities.length);
            // this.activities.push.apply(this.activities, resp.data.activities);
            // console.log("pushing activities", this.activities);
            //this.activities = this.activities.push.apply(resp.data.activities;
            this.activities = resp.data.activities
            this.keyStatus = resp.data.keyStatus
            deferred.resolve(resp.data)
        }, function (error) {
            console.log("error", error);
            //remove temp authentification because it did not work
            deferred.resolve([]);
        })
        return deferred.promise;
    }

    /**
     * test the primitive auth key and return the possible activities for a preselection on the client
     *
     * load a list of waivers suitable for this terminal
     */
    function loadEnabledActivities(enabledActivities) {
        var deferred = $q.defer();
        var lang = $translate.proposedLanguage() || $translate.use();
        $http.post('/apikey/photoBoth/activities?lang='+lang, {enabledActivities:enabledActivities}).then(function (resp) {
            deferred.resolve(resp.data)
        }, function (error) {
            deferred.resolve([]);
        })
        return deferred.promise;
    }

    function setPrimitiveauth(_primitiveauth) {
        this.primitiveauth = _primitiveauth;
        $cookies.put("primitiveauth", _primitiveauth, {'expires': expireDate, 'path': '/'});
    }

    function setPhoto(_photo) {
        this.photo = _photo;
        $cookies.put("photo", _photo, {'expires': expireDate, 'path': '/'});
    }

    function setCheckin(_checkin) {
        this.checkin = _checkin;
        $cookies.put("checkin", _checkin, {'expires': expireDate, 'path': '/'});
    }

    function photoActive() {
        return photo;
    }

    function checkinActive() {
        return checkin;
    }

    function hasApiKey() {
        return (primitiveauth != undefined && primitiveauth.length > 0)
    }

    function checkApiKey(newKey) {
        return primitiveauth === newKey;
    }

    function removeData() {
        $cookies.remove("primitiveauth");
        $cookies.remove("photo");
        $cookies.remove("checkin");
        $cookies.remove("activities");
        primitiveauth = "";
        photo = false;
        checkin = false;
    }

    function saveActivities(activities) {
        $cookies.put("activities", JSON.stringify(activities), {'expires': expireDate, 'path': '/'});
    }

    function setData(key, photo, checkin, activities) {
        $cookies.put("primitiveauth", key, {'expires': expireDate, 'path': '/'});
        $cookies.put("photo", photo, {'expires': expireDate, 'path': '/'});
        $cookies.put("checkin", checkin, {'expires': expireDate, 'path': '/'});
        saveActivities(activities)
    }

    return {
        setupData: setupData,
        //load from server
        photoActive: photoActive,
        checkinActive: checkinActive,
        activities: activities,
        hasApiKey: hasApiKey,
        removeData: removeData,
        checkApiKey: checkApiKey,
        setData: setData,
        setPhoto: setPhoto,
        setPrimitiveauth: setPrimitiveauth,
        setCheckin: setCheckin,
        getPhoto: function () {
            return this.photo
        },
        getCheckin: function () {
            return this.checkin
        },
        setActivities: function(activities) {
            saveActivities(activities)
        },
        getActivities: function() {
            return this.activities
        },
        retreiveActivities: retreiveActivities,
        loadEnabledActivities: loadEnabledActivities
    };
};


(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('SetupController', SetupController)

    /**
     * define what this client can do. Without the proper auth no selfcheckin is possible except you have an invitation with a valid security key.
     */
    /** @ngInject */
    function SetupController($cookies, $state, setupService) {
        var vm = this;

        function initData() {
            vm.photo = setupService.getPhoto();
            vm.keyValid = setupService.hasApiKey();
            vm.key = "";
            vm.checkin = setupService.getCheckin();
            vm.enabledActivities = setupService.getActivities();
        }
        initData();

        vm.checkKey = function () {
            //doublecheck old key matches new key.
            //retreive activities from server, if available key is valid and result will be saved
            setupService.setPrimitiveauth(vm.key);
            setupService.retreiveActivities(vm.key).then(function(result) {
                //only store api key in setup
                //store keyStatus and activities in controller, show setup possibilities
                vm.keyStatus = result.keyStatus;
                vm.activities = result.activities;
                //load old values
                vm.photo = setupService.getPhoto();
                vm.checkin = setupService.getCheckin();
                vm.enabledActivities = setupService.getActivities();

            }, function(error) {
                //remove key again. not valid.
                alert(error.error)
                console.log("erorr", error);
            })
        }

        vm.saveData = function() {
            if (vm.keyStatus == "OK") {
                setupService.setData(vm.key, vm.photo,vm.checkin, vm.enabledActivities);
                initData();
                $state.reload();
            }
        }

        // Toggle selection for a given fruit by name
        vm.toggleSelection = function toggleSelection(activity) {
            var idx = vm.enabledActivities.indexOf(activity.id);

            // Is currently selected
            if (idx > -1) {
                vm.enabledActivities.splice(idx, 1);
            }

            // Is newly selected
            else {
                vm.enabledActivities.push(activity.id);
            }
            console.log(vm.enabledActivities);
        };

        vm.clearData = function() {
            setupService.removeData();
            initData();
            $state.reload();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('QrController', QrController)

    /** @ngInject */
    function QrController($timeout, $q, $http, $stateParams, $state, $translate, $rootScope, Idle, setupService, waiverService) {
        var vm = this;
        vm.loading = true;
        vm.waiverId = $stateParams.id
        vm.accessKey = $stateParams.a
        //confirm the waver key and id, returns a signaturerequest. redirect to waver after that.
        waiverService.qrInvite(vm.waiverId, vm.accessKey).then(function (data) {
            $state.go('waiver', {securitykey: data.securitykey})
        }, function(error){
            console.log(error)
        });

    }

})();

angular
    .module('selfservice')
    .factory('photoService', photoService)
    .service('bothCart', bothCartService)
    .controller('photoModalCtrl', photoModalCtrl)


/** @ngInject */
function photoService($rootScope, $q, $http, $translate, bothCart) {
    var photos = [];
    var activescheduleId;

    function loadData(activityId, activeScheduleId) {
        var deferred = $q.defer();
        $http.get('/apikey/photoBoth?activeScheduleId=' + activeScheduleId+"&activityId="+activityId).then(function (success) {
            photos = success.data.photos;
            bothCart.setPhotoArticles(success.data.photoArticles);
            bothCart.setMerch(success.data.merchantiseArticles);
            activescheduleId = success.data.activeScheduleId;
            deferred.resolve(success.data);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    }

    return {
        //load from server
        loadPhotoData: loadData
    };
}
;
/** @ngInject */
function bothCartService($rootScope, $q, $http, $state, $translate, dialogs, cartItem) {
    //the shopcart
    this.merch = [];
    this.photoArticles = [];

    this.init = function () {
        this.$cart = {
            shipping: null,
            taxRate: null,
            tax: null,
            items: []
        };
    };

    this.openPhotoModal = function (photo) {
        //variable required to pass cart to inner of dlg.result (this is different there)
        var cart = this.getCart()
        var article = this.photoArticles[0];
        var dlg = dialogs.create(
            'app/photo/addPhotoModal.html',
            'photoModalCtrl', {photo: photo});

        dlg.result.then(function (result) {
            if (result.go=='continue' || result.go == 'checkout') {
                cart.items.push(new cartItem(article.id, article.name + " Nr.: "+photo.nrOfDay, article.price, 1, photo));
            }
            if (result.go=='checkout') {
                $state.go('checkout')
            }
        });

        // var inCart = this.getItemById(id);
        //
        // if (typeof inCart === 'object'){
        //     //Update quantity of an item if it's already in the cart
        //     inCart.setQuantity(quantity, false);
        //     $rootScope.$broadcast('ngCart:itemUpdated', inCart);
        // } else {
        //     var newItem = new ngCartItem(id, name, price, quantity, data);
        //     this.$cart.items.push(newItem);
        //     $rootScope.$broadcast('ngCart:itemAdded', newItem);
        // }
        //
        // $rootScope.$broadcast('ngCart:change', {});
    };

    this.setMerch = function (merch) {
        this.merch = merch;
    }

    this.setPhotoArticles = function (articles) {
        this.photoArticles = articles;
    }

    this.getPhotoArticles = function (articles) {
        return this.photoArticles;
    }

    this.setCart = function (cart) {
        this.$cart = cart;
        return this.getCart();
    };

    this.getCart = function () {
        return this.$cart;
    };

    this.getItems = function () {
        return this.getCart().items;
    };

    this.getTotalItems = function () {
        var count = 0;
        var items = this.getItems();
        angular.forEach(items, function (item) {
            count += item.getQuantity();
        });
        return count;
    };

    this.getTotalUniqueItems = function () {
        return this.getCart().items.length;
    };

    this.getSubTotal = function () {
        var total = 0;
        angular.forEach(this.getCart().items, function (item) {
            total += item.getTotal();
        });
        return +parseFloat(total).toFixed(2);
    };

    this.totalCost = function () {
        return +parseFloat(this.getSubTotal()).toFixed(2);
    };

    this.removeItem = function (index) {
        var item = this.$cart.items.splice(index, 1)[0] || {};
        $rootScope.$broadcast('ngCart:itemRemoved', item);
        $rootScope.$broadcast('ngCart:change', {});

    };

    this.removeItemById = function (id) {
        var cart = this.getCart();
        angular.forEach(cart.items, function (item, index) {
            if (item.getId() === id) {
                console.log("removing item ");
                console.log(item);
                item = cart.items.splice(index, 1)[0] || {};
            }
        });
        this.setCart(cart);
        $rootScope.$broadcast('ngCart:itemRemoved', item);
        $rootScope.$broadcast('ngCart:change', {});
    };

    this.empty = function () {
        $rootScope.$broadcast('ngCart:change', {});
        this.$cart.items = [];
    };

    this.isEmpty = function () {
        return (this.$cart.items.length > 0 ? false : true);
    };

    this.toObject = function() {
        if (this.getItems().length === 0) return false;

        var items = [];
        angular.forEach(this.getItems(), function(item){
            items.push (item.toObject());
        });

        return {
            totalCost: this.totalCost(),
            items:items
        }
    };

}
/** @ngInject */
function photoModalCtrl($scope, data, $uibModalInstance, bothCart) {
    $scope.photo = data.photo;

    $scope.addAndCheckout = function () {
        $uibModalInstance.close({go: "checkout"});
    }

    $scope.add = function () {
        $uibModalInstance.close({go: "continue"});
    }

    $scope.cancel = function () {
        $uibModalInstance.dismiss()
    };
}
;


(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('PhotoController', PhotoController)
        .controller('PhotoSliderController', PhotoSliderController)
        .directive('bgImage', BgImage)

    /** @ngInject */
    function PhotoController($timeout, $q, $http, $state, $stateParams, $scope, photoService, $translate, photodata, Idle, bothCart) {
        var pc = this;
        Idle.watch();
        pc.bothCart = bothCart;
        pc.selectedActivityId = photodata.activityId;
        pc.photos = photodata.photos;
        pc.schedules = photodata.schedules;
        pc.activeScheduleId = photodata.activeScheduleId;
        pc.selectScheduleTime = function(activeScheduleId) {
            console.log(pc.selectedActivityId);
            $state.go('.', {
                activeScheduleId: activeScheduleId,
                activityId: pc.selectedActivityId
            })
        }

        pc.viewSlider = function(activeScheduleId, securitykey) {
            $state.go('photoSlider', {
                activeScheduleId: activeScheduleId,
                activityId: pc.selectedActivityId,
                securitykey: securitykey
            })
        }

        pc.nameDropdown = _.chain(photodata.photos).groupBy("flyerName")
            .map(function(value, key) {
                return ({name: key, photos: value})
            }).value()
    }

    /** @ngInject */
    function PhotoSliderController($timeout, $q, $http, $state, $stateParams, $scope, photoService, $translate, photodata, Idle, bothCart) {
        var pcs = this;
        Idle.watch();

        pcs.photoId = parseInt($stateParams.photoId) || 0;
        pcs.bothCart = bothCart;
        pcs.photos = [];
        pcs.schedules = photodata.schedules;
        pcs.activeScheduleId = photodata.activeScheduleId;
        pcs.selectedActivityId = photodata.activityId;
        pcs.activeSchedule = _.find(pcs.schedules, function(schedule) {
            return schedule.scheduleId === parseInt(pcs.activeScheduleId)
        })

        angular.forEach(photodata.photos, function(photo) {
            pcs.photos.push({
                id: photo.id,
                url: "/photo/"+photo.securitykey+"/show",
                title: "Nr.: "+photo.nrOfDay+" "+photo.flyerName,
                nrOfDay: photo.nrOfDay,
                flyerName: photo.flyerName,
                startTime: pcs.activeSchedule.startTime,
                scheduleId: pcs.activeSchedule.scheduleId,
                securitykey: photo.securitykey,
            })
        });

        pcs.activeScheduleId = photodata.activeScheduleId;
        pcs.selectScheduleTime = function(activeScheduleId) {
            $state.go('.', {
                activeScheduleId: activeScheduleId,
                activityId: main.activityId
            })
        }

        pcs.setCurrentSlideIndex = function (index) {
            pcs.direction = (index > pcs.currentIndex) ? 'left' : 'right';
            pcs.currentIndex = index;
        };

        pcs.isCurrentSlideIndex = function (index) {
            return pcs.currentIndex === index;
        };

        pcs.methods = {};
    }

    /** @ngInject */
    function BgImage($window, $timeout) {
        return function (scope, element, attrs) {
                var resizeBG = function () {
                    var bgwidth = element.width();
                    var bgheight = element.height();
                    var winwidth = $window.innerWidth;
                    var winheight = $window.innerHeight;
                    var widthratio = winwidth / bgwidth;
                    var heightratio = winheight / bgheight;
                    var widthdiff = heightratio * bgwidth;
                    var heightdiff = widthratio * bgheight;
                    if (heightdiff > winheight) {
                        element.css({
                            width: winwidth + 'px',
                            height: heightdiff + 'px'
                        });
                    } else {
                        element.css({
                            width: widthdiff + 'px',
                            height: winheight + 'px'
                        });
                    }
                };
                var windowElement = angular.element($window);
                windowElement.resize(resizeBG);
                element.bind('load', function () {
                    resizeBG();
                });
            }
    };

})
();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .directive('header', headerDirective)
        .controller('headerCtrl', headerCtrl)
        .directive('footer', footerDirective)
        .directive('copyright', copyrightDirective)


    /** @ngInject */
    function headerDirective() {
        return {
            restrict: "A",
            replace: false,
            templateUrl: "app/navigation/header.html",
            controller: "headerCtrl"
        };
    }

    /** @ngInject */
    function footerDirective() {
        return {
            restrict: "A",
            replace: false,
            templateUrl: "app/navigation/footer.html"
        };
    }

    /** @ngInject */
    function copyrightDirective() {
        return {
            restrict: "A",
            replace: false,
            templateUrl: "app/navigation/copyright.html"
        };
    }

    /** @ngInject */
    function headerCtrl($timeout, $scope, $state, $uibModal, Idle, bothCart, setupService) {
        $scope.showNav = false;

        function closeModals() {
            if ($scope.warning) {
                $scope.warning.close();
                $scope.warning = null;
            }

            if ($scope.timedout) {
                $scope.timedout.close();
                $scope.timedout = null;
            }
        }

        $scope.bothCart = bothCart;

        $scope.photoActive = setupService.getPhoto();
        $scope.checkinActive = setupService.getCheckin();
        /**
         * detect idle, if idle return to main screen
         */
        $scope.$on('IdleStart', function() {
            closeModals();

            $scope.warning = $uibModal.open({
                templateUrl: 'app/navigation/idleWarning.html',
                windowClass: 'modal-danger'
            });
        });

        $scope.$on('IdleEnd', function() {
            closeModals();
        });

        $scope.$on('IdleTimeout', function() {
            closeModals();
            $state.go('home');
        });

        $scope.goToCart = function() {
            $state.go("cart",{});
        }

        $scope.start = function() {
            closeModals();
            Idle.watch();
            $scope.started = true;
        };

        $scope.stop = function() {
            closeModals();
            Idle.unwatch();
            $scope.started = false;

        };

    }

})();






(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('LangSelectCtrl', LangSelectCtrl)
        .directive('langSelector', langSelDirective)
        .directive('langSelectorMenue', langSelMenuDirective)
        .directive('langSelectorList', langSelListDirective)

    /** @ngInject */
    function LangSelectCtrl($timeout, $q, $http, $stateParams, $state, $translate, $rootScope) {
        var vm = this;
        vm.lang = $translate.proposedLanguage() || $translate.use();
        vm.language = getLanguageFullName(vm.lang);

        //dynamically create a list of available languages
        vm.availableLanguages = [];
        _.each($translate.getAvailableLanguageKeys(), function(l) {
             vm.availableLanguages.push({iso: l, fullName: getLanguageFullName(l)})
        });

        function getLanguageFullName(shortname) {
            switch (shortname) {
                case '':
                    return "English";
                    break;
                case 'de':
                    return "Deutsch";
                    break;
                case 'es':
                    return "Español";
                    break;
                case 'en':
                    return "English";
                    break;
                case 'ca':
                    return "Català";
                    break;
                case 'fr':
                    return "Français";
                    break;

                default:
                    return "undefined";
                    break;
            }
        };

        vm.changeLanguage = function (langKey) {
            $translate.use(langKey);
            //avoid race condition with langugage loader on first click
            vm.lang = $translate.proposedLanguage();
            $http.defaults.headers.common['lang'] = vm.lang;

            if (!vm.lang) {
                vm.lang = $translate.storage().get($translate.storageKey());
            }

            //monitor language selection changes
            $rootScope.$on('$translateChangeEnd', function () {
                //reload texts (json dependencies)
                if ($translate.use()) {
                    vm.lang = $translate.use();
                    vm.language = getLanguageFullName(vm.lang);
                }
            });
        };
    }

    /** @ngInject */
    function langSelDirective() {
        return {
            restrict: "A",
            replace: false,
            templateUrl: "app/navigation/langselect.html",
            controller: "LangSelectCtrl",
            controllerAs: "lang"
        };
    }

    /** @ngInject */
    function langSelMenuDirective() {
        return {
            restrict: "A",
            replace: true,
            templateUrl: "app/navigation/langselect_menue.html",
            controller: "LangSelectCtrl",
            controllerAs: "lang"
        };
    }
    /** @ngInject */
    function langSelListDirective() {
        return {
            restrict: "E",
            replace: true,
            templateUrl: "app/navigation/langselect_list.html",
            controller: "LangSelectCtrl",
            controllerAs: "lang"
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('MainController', MainController)

    /** @ngInject */
    function MainController($timeout, $q, $http, $stateParams, $state, $translate, $rootScope, Idle, setupService, waiverService) {
        var vm = this;
        Idle.unwatch();
        vm.loading = true;
        vm.waivers = undefined;
        vm.selectedActivity = undefined;

        vm.formOptions = {};

        $rootScope.$on('$translateChangeEnd', function () {
            $state.reload();
        })

        //redirect to empty page

        //setup params if they arrive with a link
        if ($stateParams.apikey) {
            if ($stateParams.apikey.length > 4) {
                setupService.setPrimitiveauth($stateParams.apikey)
            }
        }

        if ($stateParams.photo) {
            setupService.setPhoto("true" == $stateParams.photo || "True" == $stateParams.photo);
        }

        if ($stateParams.checkin) {
            setupService.setCheckin("true" == $stateParams.checkin || "True" == $stateParams.checkin);
        }

        if ($stateParams.activities) {
            var selectedActivities = $stateParams.activities.split(",")
            setupService.setActivities(selectedActivities)
        }

        vm.photoActive = setupService.getPhoto();
        vm.checkinActive = setupService.getCheckin();

        //callback from directive
        vm.selectActivity = function (selectedActivity) {
            vm.waivers = selectedActivity.waivers;
            vm.selectedActivity = selectedActivity;
        }

        vm.blankInvite = function (waiverId) {
            waiverService.blankInvite(waiverId).then(function (data) {
                $state.go('waiver', {securitykey: data.securitykey})
            });
        }
    }

})();

/**
 * Each section of the site has its own module. It probably also has
 * submodules, though this boilerplate is too simple to demonstrate it. Within
 * `src/app/home`, however, could exist several additional folders representing
 * additional modules that would then be listed as dependencies of this one.
 * For example, a `note` section could have the submodules `note.create`,
 * `note.delete`, `note.edit`, etc.
 *
 * Regardless, so long as dependencies are managed correctly, the build process
 * will automatically take take of the rest.
 *
 * The dependencies block here is also where component dependencies should be
 * specified, as shown below.
 */
angular.module('booking.auth', [])

/**
 * Each section or module of the site can also have its own routes. AngularJS
 * will handle ensuring they are all available at run-time, but splitting it
 * this way makes each module more "self-contained".
 */
    .config(function config($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                controller: 'LoginController',
                templateUrl: 'app/login/login.tpl.html'
            });
    })

/**
 * And of course we define a controller for our route.
 */
    .controller('LoginController', function LoginController($scope, $state, $stateParams, $auth, SweetAlert) {
        $scope.username = "";
        $scope.password = "";
        $scope.rememberMe = false;
        $scope.loginalerts = [];

        $scope.login = function () {
            var v = {
                username: $scope.username,
                password: $scope.password
            };
            $auth.submitLogin(v).then(function (resp) {
                //$state.go('home',{reload:true});
                // handle success response
            }, function (resp) {
                SweetAlert.swal("Fehler", "Anmeldung fehlgeschlagen", "error");
                console.log("login fail");
                $scope.password ="";
                // handle error response
            });
        };
    })
;


(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('EmptyController', EmptyController)

    /** @ngInject */
    function EmptyController($timeout, $q, $http, $stateParams, $state, $translate, $rootScope, Idle, setupService, waiverService) {
    }

})();

angular.module('globalDirectives', [])

//calculate the delay between the start of the session and the real start
    .directive('delaydisplay', function (moment) {
        return {
            restrict: 'EA',
            scope: {
                schedule: '=',
                format: '@'
            },
            link: function (scope, element, attrs) {
                scope.format = angular.isDefined(scope.format) ? scope.format=='true' : true;

                var setText = function () {
                    if (!scope.schedule || !scope.schedule.realFlightStart) {
                        element.text("");
                        return;
                    }
                    var now = moment(scope.schedule.realFlightStart)
                    var then = moment(scope.schedule.startdate);

                    var ms = now.diff(then);
                    var d = moment.duration(ms);
                    var s = d.asSeconds();
                    s = Math.floor(s/60);
                    var slotTime = "";
                    if (d > 0) {
                        element.text("<span class=''>Delay: "+s+" Min</span>");
                        if (scope.format) {
                            element.css({backgroundColor: "rgb(255, 223, 223)", padding:"5px", "margin-left":"10px", "font-style": "italic"});
                        }
                    } else {
                        element.text("");
                        if (scope.format) {
                            element.css({backgroundColor: ""});
                        }
                    }
                }
                setText();
                //only watch for second changes, time or slot number will never change.
                if (scope.schedule) {
                    scope.$watch('schedule.realFlightStart', function (newValue, oldValue) {
                        setText();
                    });
                }
            }
        };
    })

    .directive('remainingflights', function (moment) {
        return {
            restrict: 'EA',
            scope: {
                schedule: '=',
            },
            link: function (scope, element, attrs) {
                var setText = function () {
                    if (!scope.schedule || !scope.schedule.realFlightStart) {
                        element.text("");
                        return;
                    }
                    console.log(scope.schedule.flights);
                    _.count()
                    if (d > 0) {
                        element.text("<span class='smallLabel'>Delay: "+s+"</span>");
                        if (scope.format) {
                            element.css({backgroundColor: "rgb(255, 223, 223)", padding:"5px", "margin-left":"10px"});
                        }
                    } else {
                        element.text("");
                        if (scope.format) {
                            element.css({backgroundColor: ""});
                        }
                    }
                }
                setText();
                //only watch for second changes, time or slot number will never change.
                if (scope.schedule) {
                    scope.$watch('schedule.realFlightStart', function (newValue, oldValue) {
                        setText();
                    });
                }
            }
        };
    })


    /**
 * convert second time to mm:ss
 */
    .filter('flighttime', function () {
        return function (input) {
            if (!input) return "00:00"
            var negativePrefix = "";
            if (input <0) {
                negativePrefix = " - "
                input = Math.abs(input)
            }
            var seconds = Math.floor(input % 60);
            var hours = Math.floor(input / 60 / 60);
            var minutes = Math.floor((input-hours*60*60) / 60);
            minutes = (minutes < 10 && minutes >= 0) ? ("0" + minutes) : minutes;
            seconds = (seconds < 10) ? ("0" + seconds) : seconds;
            if (hours > 0) {
                return negativePrefix+hours +":"+ minutes + ":" + seconds;
            } else {
                return negativePrefix+minutes + ":" + seconds;
            }
        };
    })
    .filter('flightminutes', function () {
        return function (input) {
            var seconds = input % 60;
            var minutes = Math.floor(input / 60);
            return minutes;
        };
    })
/**
 * convert the slots (0-47) to the time value (00:00 to 24:00)
 * 0 -> 0:00
 * 1 -> 0:30
 * 2 -> 1:00
 */
    .filter('slottotime', function () {
        return function (input) {
            var minutes = input % 2 * 30;
            var hours = Math.ceil((input - 1) / 2);
            minutes = (minutes < 10) ? ("0" + minutes) : minutes;
            hours = (hours < 10) ? ("0" + hours) : hours;
            return hours + ":" + minutes;
        };
    })

/**
 * convert the free seconds to free minutes, round down
 * 60 -> 1
 * 120 -> 2
 * 150 -> 2
 */
    .filter('slotminutes', function () {
        return function (input) {
            var minutes = Math.ceil(input / 60);
            return minutes;
        };
    })

    .directive('pdfDownload', function () {
        return {
            restrict: 'E',
            template: '<a href="" class="btn btn-primary" ng-click="downloadPdf()">Download</a>',
            scope: true,
            link: function (scope, element, attr) {
                var anchor = element.children()[0];

                // When the download starts, disable the link
                scope.$on('download-start', function () {
                    $(anchor).attr('disabled', 'disabled');
                });

                // When the download finishes, attach the data to the link. Enable the link and change its appearance.
                scope.$on('downloaded', function (event, data) {
                    $(anchor).attr({
                        href: 'data:application/pdf;base64,' + encodeURIComponent(data),
                        download: attr.filename
                    })
                        .removeAttr('disabled')
                        .text('Save')
                        .removeClass('btn-primary')
                        .addClass('btn-success');

                    // Also overwrite the download pdf function to do nothing.
                    scope.downloadPdf = function () {
                    };
                }, function (error) {
                    console.log("error");
                    console.log(error);
                    $(anchor).removeAttr('disabled')
                        .text('Download');

                });
            },
            controller: ['$scope', '$attrs', '$http', function ($scope, $attrs, $http) {
                $scope.downloadPdf = function () {
                    $scope.$emit('download-start');
                    $http.get($attrs.url).then(function (response) {
                        $scope.$emit('downloaded', response.data);
                    });
                };
            }]
        };
    })

    //layout the address, used multiple times in the admin interface
    .directive('purchaseaddress', function () {
        return {
            restrict: 'A',
            scope: {
                color: '@',
                address: '='
            },
            template: '<ul class="list-unstyled spaced">' +
            '<li><i class="icon-caret-right {{color}}"></i>{{address.firstname}}, {{address.lastname}}</li>' +
            '<li><i class="icon-caret-right {{color}}"></i>{{address.company}}</li>' +
            '<li><i class="icon-caret-right {{color}}"></i>{{address.street1}}</li>' +
            '<li ng-show="address.street2"><i class="icon-caret-right {{color}}"></i>{{address.street2}}</li>' +
            '<li><i class="icon-caret-right {{color}}"></i>{{address.zip}}, {{address.city}}</li>' +
            '<li ng-show="address.state"><i class="icon-caret-right {{color}}"></i>{{address.state}}, {{address.countrycode}}</li>' +
            '<li ng-hide="address.state"><i class="icon-caret-right {{color}}"></i>{{address.countrycode}}</li>' +
            '<li><i class="icon-caret-right {{color}}"></i>Phone: <b class="red">{{address.phone}}</b></li>' +
            '</ul>'
        };
    })

    .directive('modelblur', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attr, ngModelCtrl) {
                if (attr.type === 'radio' || attr.type === 'checkbox') {
                    return;
                }

                elm.unbind('input').unbind('keydown').unbind('change');
                elm.bind('blur', function () {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(elm.val());
                    });
                });
            }
        };
    })


// enter on input field sets value of input field instead of keeping model and value in sync all of the time
    .directive('modelenter', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attr, ngModelCtrl) {
                elm.unbind('input').unbind('keydown');
                elm.unbind('input').unbind('change');
                elm.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(elm.val());
                        });
                        event.preventDefault();
                    }
                });
                //otherwhise button submission does not work at all.
                elm.bind("change", function (event) {
                    ngModelCtrl.$setViewValue(elm.val());
                });
            }
        };
    })

    // /*
    //  This directive allows us to pass a function in on an enter key to do what we want.
    //  *@see http://ericsaupe.com/angularjs-detect-enter-key-ngenter/
    //  */
    // .directive('ngEnter', function () {
    //     return function (scope, element, attrs) {
    //         element.bind("keydown keypress", function (event) {
    //             if (event.which === 13) {
    //                 scope.$apply(function () {
    //                     scope.$eval(attrs.ngEnter);
    //                 });
    //
    //                 event.preventDefault();
    //             }
    //         });
    //     };
    // })

    .directive('ngEnter', function($document) {
        return {
            scope: {
                ngEnter: "&"
            },
            link: function(scope, element, attrs) {
                var enterWatcher = function(event) {
                    if (event.which === 13) {
                        scope.ngEnter();
                        scope.$apply();
                        event.preventDefault();
                        $document.unbind("keydown keypress", enterWatcher);
                    }
                };
                $document.bind("keydown keypress", enterWatcher);
            }
        }
    })

    //seehttp://stackoverflow.com/questions/14833326/how-to-set-focus-in-angularjs
    .directive('focus', function ($timeout, $parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(attrs.focus, function (newValue, oldValue) {
                    if (newValue) {
                        element[0].select();
                        //element[0].setSelectionRange(0,9999);
                    }
                });
                element.bind("blur", function (e) {
                    $timeout(function () {
                        scope.$apply(attrs.focus + "=false");
                    }, 0);
                });
                element.bind("focus", function (e) {
                    $timeout(function () {
                        scope.$apply(attrs.focus + "=true");
                    }, 0);
                });
            }
        };
    })

    .directive('backButton', ['$window', function($window) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.bind('click', function () {
                    $window.history.back();
                });
            }
        };
    }])

//basic concept taken from
//http://icelab.com.au/articles/levelling-up-with-angularjs-building-a-reusable-click-to-edit-directive/
//maybe update with enterlistener, example here:http://jsfiddle.net/bonamico/cAHz7/
    .directive("clickToEdit", function () {
        var editorTemplate = '<div class="click-to-edit">' +
            '<div ng-hide="view.editorEnabled">{{value}} ' +
            '<a ng-click="enableEditor()"> <i class="icon-edit bigger-110"></i></a>' +
            '</div>' +
            '<div ng-show="view.editorEnabled">' +
            '<input ng-model="view.editableValue">' +
            '<a ng-click="save()"> <i class="icon-save green bigger-110"></i></a>' +
            ' ' +
            '<a ng-click="disableEditor()"><i class="icon-remove red bigger-110"></i></a>' +
            '</div>' +
            '</div>';

        return {
            restrict: "A",
            replace: true,
            template: editorTemplate,
            scope: {
                value: "=clickToEdit",
                saveAction: "&"
            },
            controller: function ($scope, $timeout) {
                $scope.view = {
                    editableValue: $scope.value,
                    editorEnabled: false
                };

                $scope.enableEditor = function () {
                    $scope.view.editorEnabled = true;
                    $scope.view.editableValue = $scope.value;
                };

                $scope.disableEditor = function () {
                    $scope.view.editorEnabled = false;
                };

                $scope.save = function () {
                    $scope.value = $scope.view.editableValue;
                    $scope.disableEditor();
                    //this is a nasty trick to get the scopes value applied in time
                    //have to figure out how to overcome this (link function?)
                    var delayme = $timeout(function () {
                        $timeout.cancel(delayme);
                        $scope.saveAction();

                    }, 10);
                };
            }
        };
    })
    .directive('emailInput', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/emailinput/email-input.template.html',
            replace: true,
            scope: {
                text: '=ngModel'
            },
            link: function (scope, element, attrs) {
                scope.name="pattern"
                scope.emailname = "";
                scope.emaildomain = "";
                if (scope.text) {
                    var atpos = scope.text.indexOf("@")
                    if (atpos > 0) {
                        scope.emailname = scope.text.substring(0, atpos)
                        scope.emaildomain = scope.text.substring(atpos+1, scope.text.length);
                    }
                }
                scope.updateMail = function () {
                    var mail = scope.emailname + "@" + scope.emaildomain;
                    scope.text = mail;
                    attrs.$set('text', scope.text);
                }
            }
        }
    })
;



'use strict';
/**
 * @name pvpCountryPicker
 * @desc Generate a list of countries as options of the select element.
 * @author Pablo Villoslada Puigcerber <pablo85@gmail.com>
 *
 * @param {string} [pvpCountryPicker=alpha2] The value to which ngModel is bound being the options 'alpha2', 'alpha3',
 * 'numeric' and 'name'. If not specified, 'alpha2' is used as default.
 * @example
 * <select ng-model="selectedCountry" pvp-country-picker="name"></select>
 */
angular.module('puigcerber.countryPicker',[])
    .provider('pvpCountries', function pvpCountries() {
        var countries = [
            {"name":"Afghanistan","alpha2":"AF","alpha3":"AFG","numeric":"004"},
            {"name":"Åland Islands","alpha2":"AX","alpha3":"ALA","numeric":"248"},
            {"name":"Albania","alpha2":"AL","alpha3":"ALB","numeric":"008"},
            {"name":"Algeria","alpha2":"DZ","alpha3":"DZA","numeric":"012"},
            {"name":"American Samoa","alpha2":"AS","alpha3":"ASM","numeric":"016"},
            {"name":"Andorra","alpha2":"AD","alpha3":"AND","numeric":"020"},
            {"name":"Angola","alpha2":"AO","alpha3":"AGO","numeric":"024"},
            {"name":"Anguilla","alpha2":"AI","alpha3":"AIA","numeric":"660"},
            {"name":"Antarctica","alpha2":"AQ","alpha3":"ATA","numeric":"010"},
            {"name":"Antigua and Barbuda","alpha2":"AG","alpha3":"ATG","numeric":"028"},
            {"name":"Argentina","alpha2":"AR","alpha3":"ARG","numeric":"032"},
            {"name":"Armenia","alpha2":"AM","alpha3":"ARM","numeric":"051"},
            {"name":"Aruba","alpha2":"AW","alpha3":"ABW","numeric":"533"},
            {"name":"Australia","alpha2":"AU","alpha3":"AUS","numeric":"036"},
            {"name":"Austria","alpha2":"AT","alpha3":"AUT","numeric":"040"},
            {"name":"Azerbaijan","alpha2":"AZ","alpha3":"AZE","numeric":"031"},
            {"name":"Bahamas (the)","alpha2":"BS","alpha3":"BHS","numeric":"044"},
            {"name":"Bahrain","alpha2":"BH","alpha3":"BHR","numeric":"048"},
            {"name":"Bangladesh","alpha2":"BD","alpha3":"BGD","numeric":"050"},
            {"name":"Barbados","alpha2":"BB","alpha3":"BRB","numeric":"052"},
            {"name":"Belarus","alpha2":"BY","alpha3":"BLR","numeric":"112"},
            {"name":"Belgium","alpha2":"BE","alpha3":"BEL","numeric":"056"},
            {"name":"Belize","alpha2":"BZ","alpha3":"BLZ","numeric":"084"},
            {"name":"Benin","alpha2":"BJ","alpha3":"BEN","numeric":"204"},
            {"name":"Bermuda","alpha2":"BM","alpha3":"BMU","numeric":"060"},
            {"name":"Bhutan","alpha2":"BT","alpha3":"BTN","numeric":"064"},
            {"name":"Bolivia (Plurinational State of)","alpha2":"BO","alpha3":"BOL","numeric":"068"},
            {"name":"Bonaire, Sint Eustatius and Saba","alpha2":"BQ","alpha3":"BES","numeric":"535"},
            {"name":"Bosnia and Herzegovina","alpha2":"BA","alpha3":"BIH","numeric":"070"},
            {"name":"Botswana","alpha2":"BW","alpha3":"BWA","numeric":"072"},
            {"name":"Bouvet Island","alpha2":"BV","alpha3":"BVT","numeric":"074"},
            {"name":"Brazil","alpha2":"BR","alpha3":"BRA","numeric":"076"},
            {"name":"British Indian Ocean Territory (the)","alpha2":"IO","alpha3":"IOT","numeric":"086"},
            {"name":"Brunei Darussalam","alpha2":"BN","alpha3":"BRN","numeric":"096"},
            {"name":"Bulgaria","alpha2":"BG","alpha3":"BGR","numeric":"100"},
            {"name":"Burkina Faso","alpha2":"BF","alpha3":"BFA","numeric":"854"},
            {"name":"Burundi","alpha2":"BI","alpha3":"BDI","numeric":"108"},
            {"name":"Cabo Verde","alpha2":"CV","alpha3":"CPV","numeric":"132"},
            {"name":"Cambodia","alpha2":"KH","alpha3":"KHM","numeric":"116"},
            {"name":"Cameroon","alpha2":"CM","alpha3":"CMR","numeric":"120"},
            {"name":"Canada","alpha2":"CA","alpha3":"CAN","numeric":"124"},
            {"name":"Cayman Islands (the)","alpha2":"KY","alpha3":"CYM","numeric":"136"},
            {"name":"Central African Republic (the)","alpha2":"CF","alpha3":"CAF","numeric":"140"},
            {"name":"Chad","alpha2":"TD","alpha3":"TCD","numeric":"148"},
            {"name":"Chile","alpha2":"CL","alpha3":"CHL","numeric":"152"},
            {"name":"China","alpha2":"CN","alpha3":"CHN","numeric":"156"},
            {"name":"Christmas Island","alpha2":"CX","alpha3":"CXR","numeric":"162"},
            {"name":"Cocos (Keeling) Islands (the)","alpha2":"CC","alpha3":"CCK","numeric":"166"},
            {"name":"Colombia","alpha2":"CO","alpha3":"COL","numeric":"170"},
            {"name":"Comoros (the)","alpha2":"KM","alpha3":"COM","numeric":"174"},
            {"name":"Congo (the)","alpha2":"CG","alpha3":"COG","numeric":"178"},
            {"name":"Congo (the Democratic Republic of the)","alpha2":"CD","alpha3":"COD","numeric":"180"},
            {"name":"Cook Islands (the)","alpha2":"CK","alpha3":"COK","numeric":"184"},
            {"name":"Costa Rica","alpha2":"CR","alpha3":"CRI","numeric":"188"},
            {"name":"Côte d'Ivoire","alpha2":"CI","alpha3":"CIV","numeric":"384"},
            {"name":"Croatia","alpha2":"HR","alpha3":"HRV","numeric":"191"},
            {"name":"Cuba","alpha2":"CU","alpha3":"CUB","numeric":"192"},
            {"name":"Curaçao","alpha2":"CW","alpha3":"CUW","numeric":"531"},
            {"name":"Cyprus","alpha2":"CY","alpha3":"CYP","numeric":"196"},
            {"name":"Czech Republic","alpha2":"CZ","alpha3":"CZE","numeric":"203"},
            {"name":"Denmark","alpha2":"DK","alpha3":"DNK","numeric":"208"},
            {"name":"Djibouti","alpha2":"DJ","alpha3":"DJI","numeric":"262"},
            {"name":"Dominica","alpha2":"DM","alpha3":"DMA","numeric":"212"},
            {"name":"Dominican Republic (the)","alpha2":"DO","alpha3":"DOM","numeric":"214"},
            {"name":"Ecuador","alpha2":"EC","alpha3":"ECU","numeric":"218"},
            {"name":"Egypt","alpha2":"EG","alpha3":"EGY","numeric":"818"},
            {"name":"El Salvador","alpha2":"SV","alpha3":"SLV","numeric":"222"},
            {"name":"Equatorial Guinea","alpha2":"GQ","alpha3":"GNQ","numeric":"226"},
            {"name":"Eritrea","alpha2":"ER","alpha3":"ERI","numeric":"232"},
            {"name":"Estonia", "alpha2":"EE","alpha3":"EST","numeric":"233"},
            {"name":"Ethiopia","alpha2":"ET","alpha3":"ETH","numeric":"231"},
            {"name":"Falkland Islands (the) [Malvinas]","alpha2":"FK","alpha3":"FLK","numeric":"238"},
            {"name":"Faroe Islands (the)","alpha2":"FO","alpha3":"FRO","numeric":"234"},
            {"name":"Fiji","alpha2":"FJ","alpha3":"FJI","numeric":"242"},
            {"name":"Finland","alpha2":"FI","alpha3":"FIN","numeric":"246"},
            {"name":"France","alpha2":"FR","alpha3":"FRA","numeric":"250"},
            {"name":"French Guiana","alpha2":"GF","alpha3":"GUF","numeric":"254"},
            {"name":"French Polynesia","alpha2":"PF","alpha3":"PYF","numeric":"258"},
            {"name":"French Southern Territories (the)","alpha2":"TF","alpha3":"ATF","numeric":"260"},
            {"name":"Gabon","alpha2":"GA","alpha3":"GAB","numeric":"266"},
            {"name":"Gambia (the)","alpha2":"GM","alpha3":"GMB","numeric":"270"},
            {"name":"Georgia","alpha2":"GE","alpha3":"GEO","numeric":"268"},
            {"name":"Germany","alpha2":"DE","alpha3":"DEU","numeric":"276"},
            {"name":"Germany","alpha2":"DE","alpha3":"DEU","numeric":"276"},
            {"name":"Ghana","alpha2":"GH","alpha3":"GHA","numeric":"288"},
            {"name":"Gibraltar","alpha2":"GI","alpha3":"GIB","numeric":"292"},
            {"name":"Greece","alpha2":"GR","alpha3":"GRC","numeric":"300"},
            {"name":"Greenland","alpha2":"GL","alpha3":"GRL","numeric":"304"},
            {"name":"Grenada","alpha2":"GD","alpha3":"GRD","numeric":"308"},
            {"name":"Guadeloupe","alpha2":"GP","alpha3":"GLP","numeric":"312"},
            {"name":"Guam","alpha2":"GU","alpha3":"GUM","numeric":"316"},
            {"name":"Guatemala","alpha2":"GT","alpha3":"GTM","numeric":"320"},
            {"name":"Guernsey","alpha2":"GG","alpha3":"GGY","numeric":"831"},
            {"name":"Guinea","alpha2":"GN","alpha3":"GIN","numeric":"324"},
            {"name":"Guinea-Bissau","alpha2":"GW","alpha3":"GNB","numeric":"624"},
            {"name":"Guyana","alpha2":"GY","alpha3":"GUY","numeric":"328"},
            {"name":"Haiti","alpha2":"HT","alpha3":"HTI","numeric":"332"},
            {"name":"Heard Island and McDonald Islands","alpha2":"HM","alpha3":"HMD","numeric":"334"},
            {"name":"Holy See (the)","alpha2":"VA","alpha3":"VAT","numeric":"336"},
            {"name":"Honduras","alpha2":"HN","alpha3":"HND","numeric":"340"},
            {"name":"Hong Kong","alpha2":"HK","alpha3":"HKG","numeric":"344"},
            {"name":"Hungary","alpha2":"HU","alpha3":"HUN","numeric":"348"},
            {"name":"Iceland","alpha2":"IS","alpha3":"ISL","numeric":"352"},
            {"name":"India","alpha2":"IN","alpha3":"IND","numeric":"356"},
            {"name":"Indonesia","alpha2":"ID","alpha3":"IDN","numeric":"360"},
            {"name":"Iran (Islamic Republic of)","alpha2":"IR","alpha3":"IRN","numeric":"364"},
            {"name":"Iraq","alpha2":"IQ","alpha3":"IRQ","numeric":"368"},
            {"name":"Ireland","alpha2":"IE","alpha3":"IRL","numeric":"372"},
            {"name":"Isle of Man","alpha2":"IM","alpha3":"IMN","numeric":"833"},
            {"name":"Israel","alpha2":"IL","alpha3":"ISR","numeric":"376"},
            {"name":"Italy","alpha2":"IT","alpha3":"ITA","numeric":"380"},
            {"name":"Jamaica","alpha2":"JM","alpha3":"JAM","numeric":"388"},
            {"name":"Japan","alpha2":"JP","alpha3":"JPN","numeric":"392"},
            {"name":"Jersey","alpha2":"JE","alpha3":"JEY","numeric":"832"},
            {"name":"Jordan","alpha2":"JO","alpha3":"JOR","numeric":"400"},
            {"name":"Kazakhstan","alpha2":"KZ","alpha3":"KAZ","numeric":"398"},
            {"name":"Kenya","alpha2":"KE","alpha3":"KEN","numeric":"404"},
            {"name":"Kiribati","alpha2":"KI","alpha3":"KIR","numeric":"296"},
            {"name":"Korea (the Democratic People's Republic of)","alpha2":"KP","alpha3":"PRK","numeric":"408"},
            {"name":"Korea (the Republic of)","alpha2":"KR","alpha3":"KOR","numeric":"410"},
            {"name":"Kuwait","alpha2":"KW","alpha3":"KWT","numeric":"414"},
            {"name":"Kyrgyzstan","alpha2":"KG","alpha3":"KGZ","numeric":"417"},
            {"name":"Lao People's Democratic Republic (the)","alpha2":"LA","alpha3":"LAO","numeric":"418"},
            {"name":"Latvia","alpha2":"LV","alpha3":"LVA","numeric":"428"},
            {"name":"Lebanon","alpha2":"LB","alpha3":"LBN","numeric":"422"},
            {"name":"Lesotho","alpha2":"LS","alpha3":"LSO","numeric":"426"},
            {"name":"Liberia","alpha2":"LR","alpha3":"LBR","numeric":"430"},
            {"name":"Libya","alpha2":"LY","alpha3":"LBY","numeric":"434"},
            {"name":"Liechtenstein","alpha2":"LI","alpha3":"LIE","numeric":"438"},
            {"name":"Lithuania","alpha2":"LT","alpha3":"LTU","numeric":"440"},
            {"name":"Luxembourg","alpha2":"LU","alpha3":"LUX","numeric":"442"},
            {"name":"Macao","alpha2":"MO","alpha3":"MAC","numeric":"446"},
            {"name":"Macedonia (the former Yugoslav Republic of)","alpha2":"MK","alpha3":"MKD","numeric":"807"},
            {"name":"Madagascar","alpha2":"MG","alpha3":"MDG","numeric":"450"},
            {"name":"Malawi","alpha2":"MW","alpha3":"MWI","numeric":"454"},
            {"name":"Malaysia","alpha2":"MY","alpha3":"MYS","numeric":"458"},
            {"name":"Maldives","alpha2":"MV","alpha3":"MDV","numeric":"462"},
            {"name":"Mali","alpha2":"ML","alpha3":"MLI","numeric":"466"},
            {"name":"Malta","alpha2":"MT","alpha3":"MLT","numeric":"470"},
            {"name":"Marshall Islands (the)","alpha2":"MH","alpha3":"MHL","numeric":"584"},
            {"name":"Martinique","alpha2":"MQ","alpha3":"MTQ","numeric":"474"},
            {"name":"Mauritania","alpha2":"MR","alpha3":"MRT","numeric":"478"},
            {"name":"Mauritius","alpha2":"MU","alpha3":"MUS","numeric":"480"},
            {"name":"Mayotte","alpha2":"YT","alpha3":"MYT","numeric":"175"},
            {"name":"Mexico","alpha2":"MX","alpha3":"MEX","numeric":"484"},
            {"name":"Micronesia (Federated States of)","alpha2":"FM","alpha3":"FSM","numeric":"583"},
            {"name":"Moldova (the Republic of)","alpha2":"MD","alpha3":"MDA","numeric":"498"},
            {"name":"Monaco","alpha2":"MC","alpha3":"MCO","numeric":"492"},
            {"name":"Mongolia","alpha2":"MN","alpha3":"MNG","numeric":"496"},
            {"name":"Montenegro","alpha2":"ME","alpha3":"MNE","numeric":"499"},
            {"name":"Montserrat","alpha2":"MS","alpha3":"MSR","numeric":"500"},
            {"name":"Morocco","alpha2":"MA","alpha3":"MAR","numeric":"504"},
            {"name":"Mozambique","alpha2":"MZ","alpha3":"MOZ","numeric":"508"},
            {"name":"Myanmar","alpha2":"MM","alpha3":"MMR","numeric":"104"},
            {"name":"Namibia","alpha2":"NA","alpha3":"NAM","numeric":"516"},
            {"name":"Nauru","alpha2":"NR","alpha3":"NRU","numeric":"520"},
            {"name":"Nepal","alpha2":"NP","alpha3":"NPL","numeric":"524"},
            {"name":"Netherlands (the)","alpha2":"NL","alpha3":"NLD","numeric":"528"},
            {"name":"New Caledonia","alpha2":"NC","alpha3":"NCL","numeric":"540"},
            {"name":"New Zealand","alpha2":"NZ","alpha3":"NZL","numeric":"554"},
            {"name":"Nicaragua","alpha2":"NI","alpha3":"NIC","numeric":"558"},
            {"name":"Niger (the)","alpha2":"NE","alpha3":"NER","numeric":"562"},
            {"name":"Nigeria","alpha2":"NG","alpha3":"NGA","numeric":"566"},
            {"name":"Niue","alpha2":"NU","alpha3":"NIU","numeric":"570"},
            {"name":"Norfolk Island","alpha2":"NF","alpha3":"NFK","numeric":"574"},
            {"name":"Northern Mariana Islands (the)","alpha2":"MP","alpha3":"MNP","numeric":"580"},
            {"name":"Norway","alpha2":"NO","alpha3":"NOR","numeric":"578"},
            {"name":"Oman","alpha2":"OM","alpha3":"OMN","numeric":"512"},
            {"name":"Österreich","alpha2":"AT","alpha3":"AUT","numeric":"040"},
            {"name":"Pakistan","alpha2":"PK","alpha3":"PAK","numeric":"586"},
            {"name":"Palau","alpha2":"PW","alpha3":"PLW","numeric":"585"},
            {"name":"Palestine, State of","alpha2":"PS","alpha3":"PSE","numeric":"275"},
            {"name":"Panama","alpha2":"PA","alpha3":"PAN","numeric":"591"},
            {"name":"Papua New Guinea","alpha2":"PG","alpha3":"PNG","numeric":"598"},
            {"name":"Paraguay","alpha2":"PY","alpha3":"PRY","numeric":"600"},
            {"name":"Peru","alpha2":"PE","alpha3":"PER","numeric":"604"},
            {"name":"Philippines (the)","alpha2":"PH","alpha3":"PHL","numeric":"608"},
            {"name":"Pitcairn","alpha2":"PN","alpha3":"PCN","numeric":"612"},
            {"name":"Poland","alpha2":"PL","alpha3":"POL","numeric":"616"},
            {"name":"Portugal","alpha2":"PT","alpha3":"PRT","numeric":"620"},
            {"name":"Puerto Rico","alpha2":"PR","alpha3":"PRI","numeric":"630"},
            {"name":"Qatar","alpha2":"QA","alpha3":"QAT", "numeric":"634"},
            {"name":"Réunion","alpha2":"RE","alpha3":"REU","numeric":"638"},
            {"name":"Romania","alpha2":"RO","alpha3":"ROU","numeric":"642"},
            {"name":"Russian Federation (the)","alpha2":"RU","alpha3":"RUS","numeric":"643"},
            {"name":"Rwanda","alpha2":"RW","alpha3":"RWA","numeric":"646"},
            {"name":"Saint Barthélemy","alpha2":"BL","alpha3":"BLM","numeric":"652"},
            {"name":"Saint Helena, Ascension and Tristan da Cunha","alpha2":"SH","alpha3":"SHN","numeric":"654"},
            {"name":"Saint Kitts and Nevis","alpha2":"KN","alpha3":"KNA","numeric":"659"},
            {"name":"Saint Lucia","alpha2":"LC","alpha3":"LCA","numeric":"662"},
            {"name":"Saint Martin (French part)","alpha2":"MF","alpha3":"MAF","numeric":"663"},
            {"name":"Saint Pierre and Miquelon","alpha2":"PM","alpha3":"SPM","numeric":"666"},
            {"name":"Saint Vincent and the Grenadines","alpha2":"VC","alpha3":"VCT","numeric":"670"},
            {"name":"Samoa","alpha2":"WS","alpha3":"WSM","numeric":"882"},
            {"name":"San Marino","alpha2":"SM","alpha3":"SMR","numeric":"674"},
            {"name":"Sao Tome and Principe","alpha2":"ST","alpha3":"STP","numeric":"678"},
            {"name":"Saudi Arabia","alpha2":"SA","alpha3":"SAU","numeric":"682"},
            {"name":"Senegal","alpha2":"SN","alpha3":"SEN","numeric":"686"},
            {"name":"Serbia","alpha2":"RS","alpha3":"SRB","numeric":"688"},
            {"name":"Seychelles","alpha2":"SC","alpha3":"SYC","numeric":"690"},
            {"name":"Sierra Leone","alpha2":"SL","alpha3":"SLE","numeric":"694"},
            {"name":"Singapore","alpha2":"SG","alpha3":"SGP","numeric":"702"},
            {"name":"Sint Maarten (Dutch part)","alpha2":"SX","alpha3":"SXM","numeric":"534"},
            {"name":"Slovakia","alpha2":"SK","alpha3":"SVK","numeric":"703"},
            {"name":"Slovenia","alpha2":"SI","alpha3":"SVN","numeric":"705"},
            {"name":"Solomon Islands","alpha2":"SB","alpha3":"SLB","numeric":"090"},
            {"name":"Somalia","alpha2":"SO","alpha3":"SOM","numeric":"706"},
            {"name":"South Africa","alpha2":"ZA","alpha3":"ZAF","numeric":"710"},
            {"name":"South Georgia and the South Sandwich Islands","alpha2":"GS","alpha3":"SGS","numeric":"239"},
            {"name":"South Sudan ","alpha2":"SS","alpha3":"SSD","numeric":"728"},
            {"name":"Spain","alpha2":"ES","alpha3":"ESP","numeric":"724"},
            {"name":"Sri Lanka","alpha2":"LK","alpha3":"LKA","numeric":"144"},
            {"name":"Sudan (the)","alpha2":"SD","alpha3":"SDN","numeric":"729"},
            {"name":"Suriname","alpha2":"SR","alpha3":"SUR","numeric":"740"},
            {"name":"Svalbard and Jan Mayen","alpha2":"SJ","alpha3":"SJM","numeric":"744"},
            {"name":"Swaziland","alpha2":"SZ","alpha3":"SWZ","numeric":"748"},
            {"name":"Sweden","alpha2":"SE","alpha3":"SWE","numeric":"752"},
            {"name":"Switzerland","alpha2":"CH","alpha3":"CHE","numeric":"756"},
            {"name":"Syrian Arab Republic","alpha2":"SY","alpha3":"SYR","numeric":"760"},
            {"name":"Taiwan (Province of China)","alpha2":"TW","alpha3":"TWN","numeric":"158"},
            {"name":"Tajikistan","alpha2":"TJ","alpha3":"TJK","numeric":"762"},
            {"name":"Tanzania, United Republic of","alpha2":"TZ","alpha3":"TZA","numeric":"834"},
            {"name":"Thailand","alpha2":"TH","alpha3":"THA","numeric":"764"},
            {"name":"Timor-Leste","alpha2":"TL","alpha3":"TLS","numeric":"626"},
            {"name":"Togo","alpha2":"TG","alpha3":"TGO","numeric":"768"},
            {"name":"Tokelau","alpha2":"TK","alpha3":"TKL","numeric":"772"},
            {"name":"Tonga","alpha2":"TO","alpha3":"TON","numeric":"776"},
            {"name":"Trinidad and Tobago","alpha2":"TT","alpha3":"TTO","numeric":"780"},
            {"name":"Tunisia","alpha2":"TN","alpha3":"TUN","numeric":"788"},
            {"name":"Turkey","alpha2":"TR","alpha3":"TUR","numeric":"792"},
            {"name":"Turkmenistan","alpha2":"TM","alpha3":"TKM","numeric":"795"},
            {"name":"Turks and Caicos Islands (the)","alpha2":"TC","alpha3":"TCA","numeric":"796"},
            {"name":"Tuvalu","alpha2":"TV","alpha3":"TUV","numeric":"798"},
            {"name":"Uganda","alpha2":"UG","alpha3":"UGA","numeric":"800"},
            {"name":"Ukraine","alpha2":"UA","alpha3":"UKR","numeric":"804"},
            {"name":"United Arab Emirates (the)","alpha2":"AE","alpha3":"ARE","numeric":"784"},
            {"name":"United Kingdom of Great Britain and Northern Ireland (the)","alpha2":"GB","alpha3":"GBR","numeric":"826"},
            {"name":"United States Minor Outlying Islands (the)","alpha2":"UM","alpha3":"UMI", "numeric":"581"},
            {"name":"United States of America (the)","alpha2":"US","alpha3":"USA","numeric":"840"},
            {"name":"Uruguay","alpha2":"UY","alpha3":"URY","numeric":"858"},
            {"name":"Uzbekistan","alpha2":"UZ","alpha3":"UZB","numeric":"860"},
            {"name":"Vanuatu","alpha2":"VU","alpha3":"VUT","numeric":"548"},
            {"name":"Venezuela (Bolivarian Republic of)","alpha2":"VE","alpha3":"VEN","numeric":"862"},
            {"name":"Vietnam","alpha2":"VN","alpha3":"VNM","numeric":"704"},
            {"name":"Virgin Islands (British)","alpha2":"VG","alpha3":"VGB","numeric":"092"},
            {"name":"Virgin Islands (U.S.)","alpha2":"VI","alpha3":"VIR","numeric":"850"},
            {"name":"Wallis and Futuna","alpha2":"WF","alpha3":"WLF","numeric":"876"},
            {"name":"Western Sahara","alpha2":"EH","alpha3":"ESH","numeric":"732"},
            {"name":"Yemen","alpha2":"YE","alpha3":"YEM","numeric":"887"},
            {"name":"Zambia", "alpha2":"ZM","alpha3":"ZMB","numeric":"894"},
            {"name":"Zimbabwe","alpha2":"ZW","alpha3":"ZWE","numeric":"716"}
        ];
        return {
            setCountries: function(listOfCountries) {
                countries = listOfCountries;
            },
            $get: function() {
                return {
                    getCountries: function() {
                        return countries;
                    }
                };
            }
        };
    })
    .directive('pvpCountryPicker', ['$compile', function($compile) {
        var PRIORITY = 1;
        return {
            priority: PRIORITY,
            terminal: true,
            controller: ['$scope', 'pvpCountries', function($scope, pvpCountries) {
                $scope.countries = pvpCountries.getCountries();
            }],
            compile: function (tElement, tAttrs) {
                if(! tAttrs.pvpCountryPicker) {
                    tAttrs.pvpCountryPicker = 'alpha2';
                }
                var ngOptions = 'country.' + tAttrs.pvpCountryPicker + ' as country.name for country in countries';
                tAttrs.$set('ngOptions',  ngOptions);

                return function postLink(scope, iElement) {
                    $compile(iElement, null, PRIORITY)(scope);
                };
            },
            restrict: 'A'
        };
    }]);

//source: https://github.com/simonstaton/angular-match-height
angular
    .module('partnermarketing.matchHeight', [])
    .directive('matchHeight', ['$rootScope', '$window', function ($rootScope, $window) {

        'use strict';

        function getElementHeight(element) {
            return $window.parseInt($window.getComputedStyle(element, null).getPropertyValue('height'), 10);
        }

        function same(selector, element) {
            // Ensure we aren't calculating based on any previously forced heights.
            removeSame(selector, element);

            var greatestHeight = 0,
                elements = findTargetElements(selector, element);

            for (var i = 0; i < elements.length; i++) {
                var height = getElementHeight(elements[i]);
                if (height > greatestHeight) {
                    greatestHeight = height;
                }
            }

            var newHeightCss = String(greatestHeight) + 'px'
            elements.map(function(element) {
                element.style.height = newHeightCss;
            });

        }

        function removeSame(selector, element) {
            var elements = findTargetElements(selector, element);
            for (var i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            }
        }

        var trimString = function(string) {
            return string.replace(/^ +/, '').replace(/ +$/, '');
        };

        var findTargetElements = function(selector, element) {
            var elements = Array.prototype.slice.call(element[0].querySelectorAll(selector));
            if(elements) {
                elements.filter(function(el) {
                    return !isHidden(el)
                });
            }
            return elements;
        };

        function isHidden(element) {
            // `offsetParent_` is used by unit tests because `offsetParent` is read-only.
            if (element.hasOwnProperty('offsetParent_')) {
                return (element.offsetParent_ === null);
            } else {
                return (element.offsetParent === null);
            }
        }

        return {
            restrict: 'A',
            scope: {
                matchHeight: '@'
            },
            compile: function compile() {
                return {
                    post: function postLink(scope, element) {
                        if (!angular.isString(scope.matchHeight)) {
                            return;
                        }
                        var targets = scope.matchHeight.split('}');
                        if (targets.length < 2) {
                            return;
                        }

                        var mediaQueriesAndTargets = [];
                        for (var i = 0; i < targets.length; i++) {
                            var mediaQuery = trimString(targets[i].replace(/^(.+)\{.+$/, '$1'));
                            var target = trimString(targets[i].replace(/^.+\{(.+)$/, '$1'));

                            if (mediaQuery === '' && target === '') {
                                continue;
                            }

                            mediaQueriesAndTargets.push([mediaQuery, target]);
                        }

                        function checkMediaQuery() {
                            for (var i = 0; i < mediaQueriesAndTargets.length; i++) {
                                var mediaQuery = mediaQueriesAndTargets[i][0];
                                var selector = mediaQueriesAndTargets[i][1];

                                if (mediaQuery === '*' ||
                                    (typeof $window.matchMedia !== 'undefined' && $window.matchMedia(mediaQuery))) {
                                    same(selector, element);
                                } else {
                                    removeSame(selector, element);
                                }
                            }
                            $rootScope.$broadcast('angularMatchHeight::resized');
                        }

                        var resizeTimer;

                        $window.addEventListener('resize', function() {
                            $window.clearTimeout(resizeTimer);
                            resizeTimer = $window.setTimeout(checkMediaQuery, 10);
                        });
                        resizeTimer = $window.setTimeout(checkMediaQuery, 10);

                        // Watch for DOM mutation, which could mean elements being inserted or styles
                        // changing, and make sure we recalculate the heights after DOM mutation.
                        var domMutationEvents = [
                            'DOMAttributeNameChanged',
                            'DOMCharacterDataModified',
                            'DOMElementNameChanged',
                            'DOMNodeInserted',
                            'DOMNodeInsertedIntoDocument',
                            'DOMNodeRemoved',
                            'DOMNodeRemovedFromDocument'
                        ];
                        for (var i = 0; i < domMutationEvents.length; i++) {
                            element[0].addEventListener(domMutationEvents[i], checkMediaQuery);
                        }
                    }
                };
            }
        };
    }]);
(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('CheckoutController', CheckoutController)
        .controller('CheckoutCompleteController', CheckoutCompleteController)

    /** @ngInject */
    function CheckoutController($timeout, $q, $http, $state, $stateParams, $scope, photoService, dialogs, $translate, Idle, bothCart, cartItem) {
        var co = this;
        Idle.watch();
        co.bothCart = bothCart;
        co.finalize = function() {
            var data = {
                cart: bothCart.getItems(),
                name: co.name,
                legal: co.acceptTerms,
                ordernotes: co.ordernotes
            };
            $http.post('/apikey/photoBoth', data).then(function (success) {
                console.log(success);
                if (success.data.status = "ok") {
                    $state.go('complete',{orderId:success.data.orderId})
                }
            }, function (error) {
                deferred.reject(error);
            });
        }
    }
    /** @ngInject */
    function CheckoutCompleteController($timeout, $q, $http, $state, $stateParams, $scope, photoService, dialogs, $translate, Idle, bothCart, cartItem) {
        var cocompl = this;
        Idle.watch();
        cocompl.orderId = $stateParams.orderId
        bothCart.empty();
    }
})
();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .controller('CartController', CartController)
        .factory('cartItem', cartItem)

    /** @ngInject */
    function CartController($timeout, $q, $http, $state, $stateParams, $scope, photoService, dialogs, $translate, Idle, bothCart, cartItem) {
        var pc = this;
        Idle.watch();
        pc.bothCart = bothCart;
    }


    /** @ngInject */
    function cartItem($rootScope, $log) {
        var item = function (id, name, price, quantity, photo) {
            this.setId(id);
            this.setName(name);
            this.setPrice(price);
            this.setQuantity(quantity);
            this.setPhoto(photo);
        };


        item.prototype.setId = function (id) {
            if (id) this._id = id;
            else {
                $log.error('An ID must be provided');
            }
        };

        item.prototype.getId = function () {
            return this._id;
        };


        item.prototype.setName = function (name) {
            if (name) this._name = name;
            else {
                $log.error('A name must be provided');
            }
        };
        item.prototype.getName = function () {
            return this._name;
        };

        item.prototype.setPrice = function (price) {
            var priceFloat = parseFloat(price);
            if (priceFloat) {
                if (priceFloat <= 0) {
                    $log.error('A price must be over 0');
                } else {
                    this._price = (priceFloat);
                }
            } else {
                $log.error('A price must be provided');
            }
        };
        item.prototype.getPrice = function () {
            return this._price;
        };


        item.prototype.setQuantity = function (quantity, relative) {
            var quantityInt = parseInt(quantity);
            if (quantityInt % 1 === 0) {
                if (relative === true) {
                    this._quantity += quantityInt;
                } else {
                    this._quantity = quantityInt;
                }
                if (this._quantity < 1) this._quantity = 1;

            } else {
                this._quantity = 1;
                $log.info('Quantity must be an integer and was defaulted to 1');
            }
        };

        item.prototype.getQuantity = function () {
            return this._quantity;
        };

        item.prototype.setPhoto = function (photo) {
            if (photo) this._photo = photo;
        };

        item.prototype.getPhoto = function () {
            if (this._photo) return this._photo;
            else $log.info('This item has no data');
        };


        item.prototype.getTotal = function () {
            return +parseFloat(this.getQuantity() * this.getPrice()).toFixed(2);
        };

        item.prototype.toObject = function () {
            return {
                id: this.getId(),
                name: this.getName(),
                price: this.getPrice(),
                quantity: this.getQuantity(),
                photo: this.getPhoto(),
                total: this.getTotal()
            }
        };

        return item;

    }

})
();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .directive('activitySelector', ActivitySelectorDirective)

    /** @ngInject */
    function ActivitySelectorDirective($timeout, $q, $http, $stateParams, $state,  $translate, $rootScope, Idle, setupService, waiverService) {
        return {
            restrict: 'AE',
            replace: true,
            templateUrl: "app/activity/activity.html",
            scope: {
                loading: '=',
                selectActivity: '&',
            },
            link: function (scope, $element, attrs, ctrl) {
                //load enabled activities from setup (cookies)
                scope.enabledActivities = setupService.getActivities();
                scope.waivers = []
                if (!scope.enabledActivities) {
                    scope.enabledActivities = [1]
                }
                /**
                 * load activities, if only one available auto select it
                 */
                scope.loading = true;
                setupService.loadEnabledActivities(scope.enabledActivities).then(function(result) {
                    //array of activity and waivers
                    scope.activities = result;
                    // if (result.length <=0) {
                    //     $state.go('empty');
                    // }
                    if (scope.activities.length == 1) {
                        scope.selectActivity({activity:scope.activities[0]})
                    }
                    scope.loading = false;

                }, function(error) {
                    console.log("error", error);
                })

                scope.select = function(activity) {
                    scope.selectActivity({activity:activity})
                }

            }
        }
    }
})();

(function () {
    'use strict';
    //remove scrollbars in chromium
    angular
        .module('selfservice')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $state, $window, $stateParams, keepalive, formlyConfig, formlyValidationMessages, bothCart, setupService, $translate) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.$themename = $window.themename;

        //keepalive.start();
        setupService.setupData()
        bothCart.init();

        formlyConfig.setType({
            name: 'radioType',
            extends: 'radio',
            templateUrl: "app/components/inline-radio.html",
        });
        // formlyConfig.extras.removeChromeAutoComplete = true;
        //define datepicker for formly, source - angular-formly page
        var attributes = [
            'date-disabled',
            'custom-class',
            'show-weeks',
            'starting-day',
            'init-date',
            'min-mode',
            'max-mode',
            'format-day',
            'format-month',
            'format-year',
            'format-day-header',
            'format-day-title',
            'format-month-title',
            'year-range',
            'shortcut-propagation',
            'datepicker-popup',
            'show-button-bar',
            'current-text',
            'clear-text',
            'close-text',
            'close-on-date-selection',
            'datepicker-append-to-body',
            'angularjs-input-birthday',
        ];

        var bindings = [
            'datepicker-mode',
            'min-date',
            'max-date'
        ];

        var ngModelAttrs = {};

        angular.forEach(attributes, function (attr) {
            ngModelAttrs[camelize(attr)] = {attribute: attr};
        });

        angular.forEach(bindings, function (binding) {
            ngModelAttrs[camelize(binding)] = {bound: binding};
        });

        formlyConfig.setType({
            name: 'datepicker',
            template: '<input-birthday ng-model="model[options.key]"></input-birthday>',
            wrapper: ['bootstrapLabel', 'bootstrapHasError'],
            defaultOptions: {
                ngModelAttrs: ngModelAttrs,
                templateOptions: {
                    datepickerOptions: {
                        format: 'yyyy-MM-dd',
                        datepickerMode: 'year'
                    }
                }
            },
            controller: ['$scope', function ($scope, $translate) {
                //                $scope.lang = $translate.proposedLanguage() || $translate.use();
                $scope.datepicker = {};
                $scope.datepicker.opened = false;
                $scope.datepicker.open = function ($event) {
                    $scope.datepicker.opened = !$scope.datepicker.opened;
                };
            }]
        });
        formlyConfig.setType({
            name: 'country',
            extends: 'input',
            template: '<select  class="form-control" ng-model="model[options.key]" pvp-country-picker></select>'
        });
        formlyConfig.setType({
            name: 'email',
            extends: 'input',
            templateUrl: 'app/waiver/email-messages.html'
        });
        formlyConfig.setType({
            name: 'signature',
            template: "<div class=\"form-group signature-field\" ng-class=\"{\'has-error\': options.formField.$invalid}\"><label for={{id}} class=\"control-label formly-label\">{{options.label || \'Signature\'}} {{options.required ? \'*\' : \'\'}} <span ng-if=!!options.fieldHelp><field-help></field-help></span></label><div mr-signature-pad id={{id}} formly-dynamic-name=options.key formly-custom-validation=options.validators data-width={{options.width}} data-height={{options.height}} data-required-expression={{options.requiredExpression}} ng-required=options.required ng-disabled=options.disabled ng-model=\"result[options.key || index]\"></div></div>"
        });


        function camelize(string) {
            string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
                return chr ? chr.toUpperCase() : '';
            });
            // Ensure 1st char is always lowercase
            return string.replace(/^([A-Z])/, function (match, chr) {
                return chr ? chr.toLowerCase() : '';
            });
        }

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            if(toState.name == 'waiver') {
                // Waiver was completed or could not load
                $state.go('home');
            }
        });

        formlyConfig.setWrapper({
            name: 'validation',
            types: ['input'],
            templateUrl: 'app/waiver/my-messages.html'
        });

        // formlyValidationMessages.addTemplateOptionValueMessage('min', 'min', '', 'is the minimum length', 'Too short');
        // formlyValidationMessages.addTemplateOptionValueMessage('pattern', 'pattern', '', 'pattern not matched', 'Pattern');
        // formlyValidationMessages.messages.pattern="pattern not matched"
        // formlyValidationMessages.messages.min="min"
    }
})();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home', {
                url: '/?:apikey&photo&checkin&activities',
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main'
            })
            .state('qr', {
                url: '/qr/?:id&:t&:a',
                templateUrl: 'app/qr/qr.html',
                controller: 'QrController',
                controllerAs: 'qr'
            })
            .state('empty', {
                url: '/empty/',
                templateUrl: 'app/empty/empty.html',
                controller: 'EmptyController',
            })
            .state('setup', {
                url: '/setup/?:key&:photo&:selfcheckin',
                templateUrl: 'app/setup/setup.html',
                controller: 'SetupController',
                controllerAs: 'setup'
            })
            .state('waiverstart', {
                url: '/waiver/start/?:id',
                templateUrl: 'app/waiver/start.html',
                controller: 'WaiverStartController',
                controllerAs: 'wsc'
            })
            .state('waiver', {
                url: '/waiver/fill/:securitykey',
                templateUrl: 'app/waiver/waiver.html',
                controller: 'WaiverController',
                controllerAs: 'wc',
                resolve: {
                    formData: function ($stateParams, waiverService) {
                        return waiverService.loadWaiver($stateParams.securitykey)
                    },
                    formModel: function ($stateParams, waiverService) {
                        return waiverService.getModel()
                    },
                }
            })
            .state('waiversignature', {
                url: '/waiver/signature/:securitykey',
                templateUrl: 'app/waiver/signature.html',
                controller: 'WaiverSignatureController',
                controllerAs: 'wsc',
                resolve: {
                    formData: function ($stateParams, waiverService) {
                        return waiverService.loadWaiver($stateParams.securitykey)
                    },
                    formModel: function ($stateParams, waiverService) {
                        waiverService.getModel()
                    }
                }
            })

            .state('invite', {
                url: '/waiver/invite?:key&:apikey',
                templateUrl: 'app/waiver/invite.html',
                controller: 'WaiverInviteController',
                controllerAs: 'wic'
            })
            .state('confirmwaiver', {
                url: '/waiver/confirm',
                templateUrl: 'app/waiver/confirm.html',
                controller: 'WaiverConfirmController',
                controllerAs: 'wcc'
            })

            .state('photo', {
                url: '/photo?activityId&activeScheduleId',
                templateUrl: 'app/photo/start.html',
                controller: 'PhotoController',
                controllerAs: 'pc',
                resolve: {
                    photodata: function ($stateParams, photoService) {
                        return photoService.loadPhotoData($stateParams.activityId, $stateParams.activeScheduleId)
                    }
                }
            })
            .state('photoSlider', {
                url: '/photoslider?activityId&activeScheduleId&photoId',
                templateUrl: 'app/photo/slider.html',
                controller: 'PhotoSliderController',
                controllerAs: 'psc',
                resolve: {
                    photodata: function ($stateParams, photoService) {
                        return photoService.loadPhotoData($stateParams.activityId, $stateParams.activeScheduleId)
                    }
                }
            })

            .state('cart', {
                url: '/cart',
                templateUrl: 'app/cart/cart.html',
                controller: 'CartController',
                controllerAs: 'cart'
            })

            .state('checkout', {
                url: '/checkout',
                templateUrl: 'app/checkout/checkout.html',
                controller: 'CheckoutController',
                controllerAs: 'co'
            })
            .state('complete', {
                url: '/complete?orderId',
                templateUrl: 'app/checkout/complete.html',
                controller: 'CheckoutCompleteController',
                controllerAs: 'cocompl'
            })

        $urlRouterProvider.otherwise('/');
    }

})
();

/* global moment:false */
(function () {
    'use strict';

    angular
        .module('selfservice')
        .constant('moment', moment)

})();

(function () {
    'use strict';

    angular
        .module('selfservice')
        .config(config);

    /** @ngInject */
    function config($logProvider, $urlRouterProvider,
                    formlyConfigProvider, $translateProvider, $windowProvider, $locationProvider, IdleProvider, KeepaliveProvider
                    //,$authProvider,RestangularProvider, authObjectProvider
    ) {
        // Enable log
        $logProvider.debugEnabled(true);

        $locationProvider.hashPrefix('');

        formlyConfigProvider.setType({
            name: 'custom',
            templateUrl: 'custom.html'
        });

        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translateProvider.translations('en', {
            'birthday-input.years': 'year',
            'birthday-input.months': 'month',
            'birthday-input.days': 'day'
        });

        $translateProvider.translations('de', {
            'birthday-input.years': 'Jahr',
            'birthday-input.months': 'Monat',
            'birthday-input.days': 'Tag'
        });

        $translateProvider.translations('es', {
            'birthday-input.years': 'Año',
            'birthday-input.months': 'Mes',
            'birthday-input.days': 'Día'
        });

        $translateProvider.translations('no', {
            'birthday-input.years': 'år',
            'birthday-input.months': 'måned',
            'birthday-input.days': 'Dag'
        });

        $translateProvider.translations('cs', {
            'birthday-input.years': 'Rok',
            'birthday-input.months': 'Měsíc',
            'birthday-input.days': 'Den'
        });

        var themename = $windowProvider.$get().themename;
        var language = "de";
        if (themename === "madrid") {
            language = "es";
            $translateProvider.registerAvailableLanguageKeys(['en', 'es'], {
                'en_US': 'en', 'en_UK': 'en', 'es_ES': 'es'
            });
            $translateProvider.fallbackLanguage('es');

        } else if (themename === "ccsfly") {
            language = "es";
            $translateProvider.registerAvailableLanguageKeys(['en', 'es'], {
                'en_US': 'en', 'en_UK': 'en', 'es_ES': 'es'
            });
            $translateProvider.fallbackLanguage('es');

        } else if (themename === "voss") {
            language = "no";
            $translateProvider.registerAvailableLanguageKeys(['no', 'en'], {
                'no_NO': 'no', 'en_UK': 'en'
            });
            $translateProvider.fallbackLanguage('no');
        } else if (themename === "flytribe") {
            language = "no";
            $translateProvider.registerAvailableLanguageKeys(['no', 'en'], {
                'no_NO': 'no', 'en_UK': 'en'
            });
            $translateProvider.fallbackLanguage('no');
        } else if (themename === "malmo") {
            language = "no";
            $translateProvider.registerAvailableLanguageKeys(['se', 'en'], {
                'se_SV': 'se', 'en_UK': 'en'
            });
            $translateProvider.fallbackLanguage('no');
        } else if (themename === "hfp") {
            language = "cs";
            $translateProvider.registerAvailableLanguageKeys(['cs', 'en'], {
                'cs_CZ': 'cs', 'en_UK': 'en'
            });
            $translateProvider.fallbackLanguage('cs');
        } else {
                language = "de";
                $translateProvider.registerAvailableLanguageKeys(['en', 'de'], {
                    'en_US': 'en', 'en_UK': 'en', 'de_DE': 'de'
                });
                $translateProvider.fallbackLanguage('en');
        }
        $translateProvider.forceAsyncReload(true);
        $translateProvider.preferredLanguage(language);
        $translateProvider.determinePreferredLanguage();
        $translateProvider.useStaticFilesLoader({
            'prefix': '/lang/locale-',
            'suffix': '.json'
        });
        $translateProvider.synchronizeLocale = true;
        $translateProvider.useCookieStorage();

        IdleProvider.idle(120);
        IdleProvider.timeout(30);
        KeepaliveProvider.interval(10);
    }
})();

angular.module("selfservice").run(["$templateCache", function($templateCache) {$templateCache.put("app/cart/cart.html","<div class=\"c-layout-breadcrumbs-1 c-fonts-uppercase c-fonts-bold c-bg-theme\"><div class=\"container\"><div class=\"c-page-title c-pull-left\"><h3 class=\"c-font-uppercase c-font-sbold c-font-white\" translate=\"LABEL_YOUR_PRODUCT_SELECTION\"></h3></div></div></div><div class=\"c-content-box c-size-sm\"><div class=\"container\"><div class=\"cbp-panel wow fadeInLeft animated\"><div class=\"c-shop-cart-page-1 c-center\" ng-show=\"bothCart.isEmpty()\"><i class=\"fa fa-frown-o c-font-dark c-font-50 c-font-thin\"></i><h2 class=\"c-font-thin c-center\" translate=\"LABEL_CART_EMPTY\"></h2><a ui-sref=\"photo()\" class=\"btn c-btn btn-lg c-btn-dark c-btn-square c-font-white c-font-bold c-font-uppercase\" translate=\"CART_CONTINUESHOP\"></a></div><div class=\"c-shop-cart-page-1\" ng-hide=\"bothCart.isEmpty()\"><div class=\"row c-cart-table-title\"><div class=\"col-md-3 c-cart-image\"><h3 class=\"c-font-uppercase c-font-bold c-font-16 c-font-grey-2\">Image</h3></div><div class=\"col-md-4 c-cart-desc\"><h3 class=\"c-font-uppercase c-font-bold c-font-16 c-font-grey-2\" translate=\"CART_DESCRIPTION\"></h3></div><div class=\"col-md-1 c-cart-qty\"><h3 class=\"c-font-uppercase c-font-bold c-font-16 c-font-grey-2\" translate=\"CART_QTY\"></h3></div><div class=\"col-md-1 c-cart-remove\"></div></div><div class=\"row c-cart-table-row\" ng-repeat=\"item in bothCart.getItems() track by $index\"><h2 class=\"c-font-uppercase c-font-bold c-theme-bg c-font-white c-cart-item-title c-cart-item-first\">{{item.getName()}}</h2><div class=\"col-md-3 col-sm-3 col-xs-5 c-cart-image\"><img ng-show=\"item.getPhoto()\" src=\"/photo/{{item.getPhoto().securitykey}}/preview\"></div><div class=\"col-sm-9 col-xs-7 c-cart-desc\"><h3><div class=\"c-font-bold c-theme-link c-font-22 c-font-dark\">{{::item.getName()}}</div></h3></div><div class=\"col-sm-3 col-xs-6 c-cart-qty text-right\"><p class=\"c-cart-sub-title c-theme-font c-font-uppercase c-font-bold\">QTY</p><div class=\"c-input-group c-spinner\">{{::item.getQuantity()}}</div></div><div class=\"col-md-1 col-sm-12 c-cart-remove\"><a ng-click=\"bothCart.removeItem($index)\" class=\"c-theme-link c-cart-remove-desktop\"><i class=\"fa fa-trash\"></i></a> <a ng-click=\"bothCart.removeItem($index)\" class=\"c-cart-remove-mobile btn c-btn c-btn-md c-btn-square c-btn-red c-btn-border-1x c-font-uppercase\">Remove item from Cart</a></div></div><div class=\"c-cart-buttons\"><a ui-sref=\"photo()\" class=\"btn c-btn btn-lg c-btn-red c-btn-square c-font-white c-font-bold c-font-uppercase c-cart-float-l\" translate=\"CART_CONTINUESHOP\"></a> <a ui-sref=\"checkout()\" class=\"btn c-btn btn-lg c-theme-btn c-btn-square c-font-white c-font-bold c-font-uppercase c-cart-float-r\" translate=\"CART_CHECKOUT\"></a></div></div></div></div></div>");
$templateCache.put("app/empty/empty.html","<div class=\"c-content-box c-size-sm c-bg-grey-1\"><div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"c-content-media-1\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"SELFCHECKIN_LABEL\">Self Checkin</h3></div><div translate=\"SELFCHECKIN_EMPTY\"></div></div></div></div></div></div>");
$templateCache.put("app/activity/activity.html","<div><div class=\"c-content-media-1\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"SELFCHECKIN_ACTIVITIES\"></h3></div><div translate=\"SELFCHECKIN_ACTIVITIES_CONTENT\"></div></div><div class=\"grid\"><figure class=\"main\" ng-class=\"{\'displaytwo\' : activities.length ==2, \'displaythree\' : activities.length==3}\" ng-repeat=\"activity in activities\"><div class=\"img\" style=\"background-image: url({{activity.img_prod}});\"></div><figcaption ng-click=\"select(activity)\"><h2 class=\"caption\"><a ng-click=\"select(activity)\">{{activity.name}}</a></h2></figcaption></figure></div></div>");
$templateCache.put("app/login/login.tpl.html","<div class=\"login\"><div class=\"logo\"></div><div class=\"content\"><form class=\"login-form\"><img src=\"assets/images/indoor_skydiving_wien_140.png\" height=\"140\" align=\"center\"><h3 class=\"form-title\">Anmeldung</h3><alert ng-repeat=\"alert in loginalerts\" type=\"error\">{{alert.msg}}</alert><div class=\"form-group\"><label class=\"control-label visible-ie8 visible-ie9\">Username</label><div class=\"input-icon\"><i class=\"fa fa-user\"></i> <input class=\"form-control placeholder-no-fix\" type=\"text\" autocomplete=\"off\" ng-model=\"username\" placeholder=\"Username\" name=\"username\" focus-on=\"username\"></div></div><div class=\"form-group\"><label class=\"control-label visible-ie8 visible-ie9\">Password</label><div class=\"input-icon\"><i class=\"fa fa-lock\"></i> <input class=\"form-control placeholder-no-fix\" type=\"password\" autocomplete=\"off\" ng-model=\"password\" placeholder=\"Password\" name=\"password\" ngenter=\"\"></div></div><div class=\"form-actions\"><button type=\"btn\" class=\"btn green\" ng-click=\"login()\">Login <i class=\"m-icon-swapright m-icon-white\"></i></button></div></form></div><div class=\"copyright\">Windobona Booking System, for interal use only!</div></div>");
$templateCache.put("app/checkout/checkout.html","<div class=\"c-content-box c-size-md c-bg-grey-1\"><div class=\"container\"><span us-spinner=\"{radius:30, width:8, length: 16}\"></span><form class=\"c-shop-form-1\"><div class=\"row\"><div class=\"col-md-7 c-padding-20\"><h3 class=\"c-font-bold c-font-uppercase c-font-24\" translate=\"LABEL_CHECKOUT_CUSTOMERDATA\"></h3><p translate=\"SELFCHECKOUT_ADD_NAME_INFO\"></p><div class=\"row\" ng-if=\"$themename!=\'barcelona\' && $themename!=\'jsa\'\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"form-group col-md-12\"><label class=\"control-label\" translate=\"LABEL_NAME\"></label> <input type=\"text\" class=\"form-control c-square c-theme\" ng-model=\"co.name\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"c-radio-list\"><div class=\"c-radio\"><input type=\"radio\" id=\"radio1\" class=\"c-radio\" name=\"payment\" checked=\"\"> <label for=\"radio1\" class=\"c-font-bold c-font-20\"><span class=\"inc\"></span> <span class=\"check\"></span> <span class=\"box\"></span> {{ \'LABEL_PAY_AT_RECEPTION\' |translate}}</label><p class=\"help-block\" translate=\"PAY_AT_RECEPTION_INFO\"></p></div></div></div></div></div><div class=\"col-md-5\"><div class=\"c-content-bar-1 c-align-left c-bordered c-theme-border c-shadow\"><h1 class=\"c-font-bold c-font-uppercase c-font-24\" translate=\"LABEL_YOUR_ORDER\"></h1><ul class=\"c-order list-unstyled\"><li class=\"row c-margin-b-15\"><div class=\"col-md-6 c-font-20\"><h2 translate=\"CART_DESCRIPTION\"></h2></div></li><li class=\"row c-border-bottom\"></li><li class=\"row c-margin-b-5 c-margin-t-5\" ng-repeat=\"item in bothCart.getItems() track by $index\"><div class=\"col-md-12 c-font-20\"><div class=\"c-theme-link\">{{::item.getName()}}</div></div></li><li class=\"row c-border-top c-margin-b-15\"></li><li class=\"row\"><div class=\"form-group col-md-12\" role=\"group\"><button ng-click=\"co.finalize()\" type=\"submit\" class=\"btn btn-lg c-theme-btn c-btn-square c-btn-uppercase c-btn-bold\" translate=\"CART_CONFIRMBOOKING\"></button></div></li></ul></div></div></div></form></div></div>");
$templateCache.put("app/checkout/complete.html","<div class=\"c-content-box c-size-md c-bg-grey-1\"><div class=\"container\"><div class=\"col-md-6\"><div class=\"c-container c-bg-img-bottom-right\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold ng-scope\" translate=\"PHOTOBOOTH_COMPLETED\"></h3><div class=\"c-line-left\"></div><div class=\"equal-height\" style=\"height: 168px;\"><p class=\"c-font-lowercase equal-height ng-scope\" translate=\"PHOTOBOOTH_COMPLETED_NEXTSTEPS\" style=\"height: 168px;\"></p><p></p><p></p><br></div></div></div></div><div class=\"col-md-6\"><div class=\"c-container c-bg-img-bottom-right fadeInDown\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold ng-scope\" translate=\"PHOTOBOOTH_ORDERID\"></h3><div class=\"c-line-left\"></div><p style=\"font-size: 168px;line-height: 120px;\">{{cocompl.orderId}}</p></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"c-content-box c-size-sm c-bg-grey-1\"><chasing-dots-spinner ng-show=\"main.loading\"></chasing-dots-spinner><div class=\"container\" ng-hide=\"main.loading\"><div class=\"col-sm-12\" ng-show=\"!main.waivers\"><activity-selector loading=\"main.loading\" select-activity=\"main.selectActivity(activity)\"></activity-selector></div><div class=\"row\" ng-show=\"main.waivers\"><div class=\"col-sm-6\" ng-show=\"main.checkinActive\"><div class=\"c-content-media-1\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"SELFCHECKIN_LABEL\">Self Checkin</h3></div><div translate=\"SELFCHECKIN_CONTENT\"></div><div ng-repeat=\"activity in main.waivers\" class=\"activity-selection\"><a ui-sref=\"waiverstart({id:activity.id})\" class=\"btn btn-md c-btn-border-2x c-btn-square c-theme-btn c-btn-uppercase c-btn-bold pull-right\" ng-hide=\"activity.skipReservation\"><i class=\"fa fa-chevron-right\"></i><span translate=\"BUTTON_START\"></span></a> <a ng-click=\"main.blankInvite(activity.id)\" class=\"btn btn-md c-btn-border-2x c-btn-square c-theme-btn c-btn-uppercase c-btn-bold pull-right\" ng-show=\"activity.skipReservation\"><i class=\"fa fa-chevron-right\"></i><span translate=\"BUTTON_START\"></span></a><h2>{{activity.name}}</h2><p>{{activity.description}}</p></div></div></div><div class=\"col-sm-6\" ng-show=\"main.photoActive\"><div class=\"c-content-media-1\"><div class=\"c-content-client-logos-1\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"SELFCHECKIN_PHOTOS\">Photos</h3></div><div translate=\"SELFCHECKIN_PHOTOCONTENT\"></div><p><a ui-sref=\"photo({activityId: main.selectedActivity.id})\" class=\"btn btn-md c-btn-border-2x c-btn-square c-theme-btn c-btn-uppercase c-btn-bold\"><i class=\"fa fa-chevron-right\"></i><span translate=\"SELFCHECKIN_STARTPHOTO_BUTTON\"></span></a></p></div></div></div></div></div></div>");
$templateCache.put("app/components/country-formly-template.html","<select ng-model=\"model[options.key]\" pvp-country-picker=\"\"></select>");
$templateCache.put("app/components/inline-radio.html","<div class=\"radio-group pull-right\"><label ng-repeat=\"(key, option) in to.options\" class=\"radio-inline\"><input type=\"radio\" id=\"{{id + \'_\'+ $index}}\" tabindex=\"0\" ng-value=\"option[to.valueProp || \'value\']\" ng-model=\"model[options.key]\"> {{option[to.labelProp || \'name\']}}</label></div><div class=\"my-messages xerror3\" ng-messages=\"fc.$error\" ng-if=\"options.formControl.$touched\" ng-messages-multiple=\"\"><div class=\"error-message xerror4\" ng-message=\"{{::name}}\" ng-repeat=\"(name, message) in ::options.validation.messages\">{{name |translate}}</div></div>");
$templateCache.put("app/navigation/copyright.html","");
$templateCache.put("app/navigation/footer.html","");
$templateCache.put("app/navigation/header.html","<header class=\"c-layout-header c-layout-header-4 c-layout-header-default-mobile\" data-minimize-offset=\"80\"><div class=\"c-navbar\"><div class=\"container\"><div class=\"c-navbar-wrapper clearfix\"><div class=\"c-brand c-pull-left\"><a class=\"c-logo\" ui-sref=\"home()\"><img src=\"/logo_140.png\" class=\"c-desktop-logo\"> <img src=\"/logo_140.png\" class=\"c-mobile-logo\"></a> <button class=\"c-hor-nav-toggler\" type=\"button\" data-target=\".c-mega-menu\" ng-click=\"showNav=!showNav\"><span class=\"c-line\"></span> <span class=\"c-line\"></span> <span class=\"c-line\"></span></button><ul class=\"langsel\"><lang-selector-list></lang-selector-list></ul></div><nav class=\"c-mega-menu c-pull-right c-mega-menu-dark c-mega-menu-dark-mobile c-fonts-uppercase c-fonts-bold\" ng-class=\"{\'c-shown\' : showNav}\"><ul class=\"nav navbar-nav c-theme-nav\"><li><a ui-sref=\"home()\" ui-sref-opts=\"{reload: true, notify: true}\" class=\"c-link dropdown-toggle\" ui-sref-active=\"c-active\"><i class=\"fa fa-home\"></i> {{\'LABEL_HOME\' | translate}} <span class=\"c-arrow c-toggler\"></span></a></li><lang-selector-list></lang-selector-list><li class=\"c-cart-toggler-wrapper\" ng-mouseenter=\"showCart=\'true\'\"><a class=\"c-btn-icon c-cart-toggler\" ng-click=\"goToCart()\"><i class=\"fa fa-shopping-cart\"></i> <span class=\"c-cart-number c-theme-bg\">{{bothCart.getTotalItems()}}</span></a></li></ul></nav></div></div></div></header>");
$templateCache.put("app/navigation/idleWarning.html","<div class=\"modal-header\"><h3 translate=\"IDLE_WARNING_HEADER\"></h3><p translate=\"IDLE_WARNING_CONTENT\"></p></div><div idle-countdown=\"countdown\" ng-init=\"countdown=5\" class=\"modal-body\"><uib-progressbar max=\"5\" value=\"5\" animate=\"false\" class=\"progress-striped active\">{{countdown}} second(s).</uib-progressbar></div>");
$templateCache.put("app/navigation/langselect.html","<div class=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-2\"><a ng-click=\"lang.changeLanguage(\'de\')\"><img src=\"assets/global/flags/at.png\"><br><span class=\"text-center\">Deutsch</span></a></div><div class=\"col-md-2\"><a ng-click=\"lang.changeLanguage(\'es\')\"><img src=\"assets/global/flags/es.png\"><br><span class=\"text-center\">Español</span></a></div><div class=\"col-md-2\"><a ng-click=\"lang.changeLanguage(\'en\')\"><img src=\"assets/global/flags/uk.png\"><br><span class=\"text-center\">english</span></a></div><div class=\"col-md-3\"></div></div>");
$templateCache.put("app/navigation/langselect_list.html","<li class=\"c-menu-type-classic\" ng-repeat=\"language in lang.availableLanguages\" ng-class=\"{active : language.iso == lang.lang}\"><a class=\"c-link dropdown-toggle langflag\" ng-click=\"lang.changeLanguage(language.iso)\"><img src=\"assets/global/flags/{{language.iso}}.png\" width=\"25px\"></a></li>");
$templateCache.put("app/navigation/langselect_menue.html","<ul class=\"c-ext c-theme-ul\"><li class=\"c-lang dropdown c-last\"><img src=\"assets/global/flags/{{lang.lang}}.png\" width=\"25px\"> <a href=\"#\">{{lang.language}}</a><ul class=\"dropdown-menu pull-right\" role=\"menu\"><li ng-repeat=\"language in lang.availableLanguages\" ng-class=\"{active : language.iso == lang.lang}\"><a ng-click=\"lang.changeLanguage(language.iso)\">{{::language.fullName}}</a></li></ul></li></ul>");
$templateCache.put("app/photo/addPhotoModal.html","<div class=\"modal-body c-bg-dark c-content-feature-15\"><div class=\"c-feature-15-container c-bg-dark\"><h2 class=\"c-feature-15-title c-font-bold c-font-uppercase c-theme-border c-font-white\" translate=\"PHOTOBOOTH_CONFIRM_HEADER\"></h2><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><img src=\"/photo/{{photo.securitykey}}/preview\" class=\"c-feature-15-img\" style=\"width: 100%\"></div><div class=\"col-md-6 col-xs-12\"><p class=\"c-feature-15-desc c-font-grey\" translate=\"PHOTOBOOTH_CONFIRM_TEXT\">Thank you for choosing a photo. You can go to the checkout and pickup your photos at the reception desk right away.</p></div><div class=\"col-md-6 col-xs-12 c-margin-b-20\"><a class=\"c-feature-15-btn btn c-btn btn-lg c-theme-btn c-font-uppercase c-font-bold c-btn-square\" ng-click=\"add()\"><i class=\"fa fa-plus\"></i> <span translate=\"CART_CONTINUESHOP\"></span></a></div><div class=\"col-md-6 col-xs-12\"><a class=\"c-feature-15-btn btn c-btn btn-lg c-theme-btn c-font-uppercase c-font-bold c-btn-square\" ng-click=\"addAndCheckout()\"><i class=\"fa fa-shopping-cart\"></i> <span translate=\"CART_CHECKOUT\"></span></a></div></div></div></div>");
$templateCache.put("app/photo/slider.html","<div class=\"c-layout-breadcrumbs-1 c-fonts-uppercase c-fonts-bold c-margin-b-10 c-bg-theme\"><div class=\"container\"><div class=\"c-page-title c-pull-left\"><h2 class=\"c-fonts-regular\">{{psc.photos.length}} Images, Session: {{psc.activeSchedule.startTime}}</h2></div><ul class=\"c-page-breadcrumbs c-theme-nav c-pull-right c-fonts-regular\"><li><a ui-href=\"home()\">Home</a></li><li>/</li><li><a ui-sref=\"photo()\">Photo</a></li><li>/</li><li class=\"c-state_active\"><span>{{psc.activeSchedule.startTime}}</span></li></ul></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"\"><ng-image-gallery images=\"psc.photos\" methods=\"psc.methods\" inline=\"true\" img-bubbles=\"false\" bubbles=\"false\" piracy=\"true\" img-anim=\"fadeup\" on-purchase=\"psc.bothCart.openPhotoModal(photo)\" start-image=\"psc.photoId\"></ng-image-gallery></div></div></div></div>");
$templateCache.put("app/photo/start.html","<div class=\"container\"><div class=\"row\"><div class=\"col-sm-8 c-margin-b-10\"><button class=\"btn btn-default c-btn-square\" translate=\"PHOTOBOOTH_SELECT_TIME\"></button> <button ng-class=\"{\'active\':schedule.scheduleId===pc.activeScheduleId}\" ng-click=\"pc.selectScheduleTime(schedule.scheduleId)\" ng-repeat=\"schedule in pc.schedules\" class=\"btn btn-default c-btn-square\">{{schedule.startTime}}</button></div><div class=\"col-sm-4\"><div class=\"input-group c-square\" about=\"\"><select class=\"form-control\" data-ng-options=\"nameObject.name as nameObject.name for nameObject in pc.nameDropdown\" ng-model=\"nameFilter\"><option value=\"\">all</option></select><span class=\"input-group-btn\"><button class=\"btn c-theme-btn c-btn-square c-btn-uppercase c-font-bold ng-scope\" type=\"button\" translate=\"LABEL_SEARCH\">Search</button></span></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-4 col-sm-6 c-margin-b-20\" ng-repeat=\"photo in pc.photos | filter:nameFilter\"><div class=\"c-content-product-2 c-bg-white c-border\"><a a=\"\" ui-sref=\"photoSlider({activityId: pc.selectedActivityId, activeScheduleId:pc.activeScheduleId, photoId:photo.id})\"><div class=\"c-content-overlay\"><div class=\"c-label c-bg-theme c-font-uppercase c-font-white c-font-16 c-font-bold\">Nr {{photo.nrOfDay}}</div><div class=\"c-bg-img-center c-overlay-object\" data-height=\"height\" style=\"height: 230px; background-image: url(/photo/{{photo.securitykey}}/preview);\"></div></div></a><div class=\"c-info\"><p class=\"c-title c-font-18 c-font-slim c-margin-b-0\">{{photo.flyerName}}</p></div><div class=\"btn-group btn-group-justified\" role=\"group\"><div class=\"btn-group c-border-top\" role=\"group\"><a ui-sref=\"photoSlider({activityId: pc.selectedActivityId, activeScheduleId:pc.activeScheduleId, photoId:photo.id})\" class=\"btn btn-lg c-btn-uppercase c-font-white c-btn-square c-bg-theme-hover c-btn-product\"><i class=\"fa fa-search\"></i> <span translate=\"LABEL_SHOW\"></span></a></div><div class=\"btn-group c-border-left c-border-top\" role=\"group\"><a class=\"btn btn-lg c-btn-uppercase c-font-white c-btn-square c-bg-theme-hover c-btn-product\" ng-click=\"pc.bothCart.openPhotoModal(photo)\"><i class=\"fa fa-shopping-cart\"></i> <span translate=\"LABEL_BUY_NOW\"></span></a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/qr/qr.html","<div class=\"c-content-box c-size-sm c-bg-grey-1\"><chasing-dots-spinner ng-show=\"main.loading\"></chasing-dots-spinner><div class=\"container\" ng-hide=\"main.loading\"><div class=\"col-sm-12\" ng-show=\"!main.waivers\"><activity-selector loading=\"main.loading\" select-activity=\"main.selectActivity(activity)\"></activity-selector></div><div class=\"row\" ng-show=\"main.waivers\"><div class=\"col-sm-6\" ng-show=\"main.checkinActive\"><div class=\"c-content-media-1\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"SELFCHECKIN_LABEL\">Self Checkin</h3></div><div translate=\"SELFCHECKIN_CONTENT\"></div><div ng-repeat=\"activity in main.waivers\" class=\"activity-selection\"><a ui-sref=\"waiverstart({id:activity.id})\" class=\"btn btn-md c-btn-border-2x c-btn-square c-theme-btn c-btn-uppercase c-btn-bold pull-right\" ng-hide=\"activity.skipReservation\"><i class=\"fa fa-chevron-right\"></i><span translate=\"BUTTON_START\"></span></a> <a ng-click=\"main.blankInvite(activity.id)\" class=\"btn btn-md c-btn-border-2x c-btn-square c-theme-btn c-btn-uppercase c-btn-bold pull-right\" ng-show=\"activity.skipReservation\"><i class=\"fa fa-chevron-right\"></i><span translate=\"BUTTON_START\"></span></a><h2>{{activity.name}}</h2><p>{{activity.description}}</p></div></div></div><div class=\"col-sm-6\" ng-show=\"main.photoActive\"><div class=\"c-content-media-1\"><div class=\"c-content-client-logos-1\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"SELFCHECKIN_PHOTOS\">Photos</h3></div><div translate=\"SELFCHECKIN_PHOTOCONTENT\"></div><p><a ui-sref=\"photo()\" class=\"btn btn-md c-btn-border-2x c-btn-square c-theme-btn c-btn-uppercase c-btn-bold\"><i class=\"fa fa-chevron-right\"></i><span translate=\"SELFCHECKIN_STARTPHOTO_BUTTON\"></span></a></p></div></div></div></div></div></div>");
$templateCache.put("app/setup/setup.html","<div class=\"c-content-box c-size-sm c-bg-grey-1\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-6\"><h1>Basic setup of the client</h1><p>Has to be done once before client can be used. Information will be stored on the client.</p><p>Please supply an apikey to limit this client to particluar waivers.</p><div class=\"c-margin-b-20\" ng-show=\"setup.keyValid\"><h1><i class=\"fa fa-check\"></i> Setup is in place.</h1><p>you can only override the settings if the new api key matches the old one. If you clear the config data the current configuration will be removed, a new one can apply.</p><button type=\"submit\" class=\"btn c-theme-btn c-btn-square c-btn-uppercase c-btn-bold\" ng-click=\"setup.clearData()\"><i class=\"fa fa-remove\"></i> Clear configdata</button></div></div><div class=\"col-md-6\"><div class=\"form-horizontal\"><div ng-show=\"setup.keyStatus != \'OK\'\"><h1>Client config</h1><p>To change the client setup enter the apikey</p><h1>Apikey</h1><input type=\"text\" class=\"form-control c-square c-theme\" ng-model=\"setup.key\"><div class=\"form-group c-margin-t-40\" ng-show=\"keyStatus != \'OK\'\"><div class=\"col-md-8\"><button type=\"submit\" class=\"btn c-theme-btn c-btn-square c-btn-uppercase c-btn-bold\" ng-click=\"setup.checkKey()\">Request access</button></div></div></div><div ng-show=\"setup.keyStatus == \'OK\'\"><h1>Configuration of this client / station</h1><p>The configuration will be stored on this device only. Use this to limit the purpose of checkin/checkout stations.</p><h1>Enabled Modules</h1><p>You can limit the features / applications used on this device</p><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"setup.photo\"> Enable Photo</label></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"setup.checkin\"> Enable selfcheckin</label></div><h1>Show Data for the following activities</h1><p>All available waivers / photos for the selected activity will be shown.</p><div class=\"checkbox\" ng-repeat=\"activity in setup.activities\"><label><input type=\"checkbox\" name=\"activity.name\" value=\"{{activity.id}}\" ng-checked=\"setup.enabledActivities.indexOf(activity.id)>-1\" ng-click=\"setup.toggleSelection(activity)\"> {{activity.name}}</label></div><button type=\"submit\" class=\"btn c-theme-btn c-btn-square c-btn-uppercase c-btn-bold\" ng-click=\"setup.saveData()\">Save</button></div></div></div></div></div></div>");
$templateCache.put("app/waiver/confirm.html","<div class=\"c-content-box c-size-xs c-bg-white\"><div class=\"container\"><div class=\"c-content-bar c-opt-1\"><div class=\"col-md-12\" translate=\"WAIVER_CONFIRM\"></div><div class=\"col-md-12\" ng-show=\"wcc.checkinActive\"><button ui-sref=\"home()\" class=\"btn c-theme-btn c-btn-square c-btn-uppercase c-font-bold\" type=\"button\" translate=\"BUTTON_BACK\"></button></div></div></div></div>");
$templateCache.put("app/waiver/email-messages.html","<email-input ng-model=\"model[options.key]\"></email-input><div class=\"my-messages\" ng-messages=\"fc.$error\" ng-if=\"options.formControl.$touched\" ng-messages-multiple=\"\"><div class=\"error-message\" ng-message=\"{{::name}}\" ng-repeat=\"(name, message) in ::options.validation.messages\">{{name |translate}}</div></div>");
$templateCache.put("app/waiver/formly-error-summary.html","");
$templateCache.put("app/waiver/invite.html","<div class=\"c-content-box c-size-xs c-bg-white\"><div class=\"container\"><div class=\"c-content-bar c-opt-1\"><div class=\"col-md-12\" translate=\"WAIVER_INVITE_WELCOME\"></div></div></div></div><div class=\"c-content-box c-size-sm c-bg-grey-1\"><div class=\"container\"><div class=\"c-content-feedback-1 c-option-1\"><div class=\"row\" match-height=\"* { .equal-height }\"><div class=\"col-md-6\"><div class=\"c-container c-bg-white c-bg-img-bottom-right\" style=\"background-image:url(assets/base/img/content/misc/feedback_box_2.png)\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\"><span translate=\"WAVER_INVITE_NAMEQUESTION\"></span> <span>{{wic.invite.firstname}} {{wic.invite.lastname}}?</span></h3><div class=\"c-line-left\"></div><div class=\"equal-height\"><p class=\"c-font-lowercase\" translate=\"WAVER_INVITE_CONFIRMNAME\"></p><br></div><a ng-click=\"wic.confirmInvite(\'customer\')\" class=\"btn btn-md c-btn-border-2x c-btn-square c-theme-btn c-btn-uppercase c-btn-bold\">start as {{wic.invite.firstname}} {{wic.invite.lastname}}</a><p translate=\"WAIVER_START_RESERVATION_QUESTIONS\"></p></div></div></div><div class=\"col-md-6\"><div class=\"c-container c-bg-green c-bg-img-bottom-right\" style=\"background-image:url(assets/base/img/content/misc/feedback_box_1.png)\"><div class=\"c-content-title-1 c-inverse\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"WAIVER_START_NORESERVATION_HEADER\">No Reservation Id?</h3><div class=\"c-line-left\"></div><p class=\"c-font-lowercase\" translate=\"WAVER_INVITE_CONFIRMNONAME\">You do not have a reservation or you cannot find your reservation id. Feel free to use this option to complete our pre-flight form.</p><p><a ng-click=\"wic.confirmInvite(\'new\')\" class=\"btn btn-md c-btn-border-2x c-btn-white c-btn-uppercase c-btn-square c-btn-bold\">Start</a></p><p translate=\"WAIVER_START_RESERVATION_QUESTIONS\">Our reception will assign you to your booking lateron.</p></div></div></div></div></div></div></div>");
$templateCache.put("app/waiver/my-messages.html","<formly-transclude></formly-transclude><div class=\"my-messages xerror2\" ng-messages=\"fc.$error\" ng-if=\"options.formControl.$touched\" ng-messages-multiple=\"\"><div class=\"error-message xerror1\" ng-message=\"{{::name}}\" ng-repeat=\"(name, message) in ::options.validation.messages\">{{name |translate}}</div></div>");
$templateCache.put("app/waiver/signature.html","<div class=\"c-content-box c-size-xs c-bg-white\"><div class=\"container\"><div class=\"c-content-bar c-opt-1\"><div class=\"col-md-12\" translate=\"WAIVER_SIGNATURE_INFO\"></div><div class=\"col-md-12\"><div ng-hide=\"wsc.signatureSaveBusy\" mr-signature-pad=\"\" ng-model=\"wsc.signature\" signature-data=\"wsc.signature2\" complete-fn=\"wsc.sign(signature)\"></div><div ng-show=\"wsc.signatureSaveBusy\" class=\"signaturebusy\"><chasing-dots-spinner></chasing-dots-spinner></div></div></div></div></div>");
$templateCache.put("app/waiver/signaturePad.html","<div class=\"signatureContainer\"><span>{{\'WAVER_SIGN_HERE\' |translate}}</span><div ng-transclude=\"\"></div><div class=\"signature\"><canvas ng-show=\"!$parent.options.disabled\"></canvas></div><button type=\"button\" class=\"btn btn-sm btn-danger pull-left\" ng-click=\"clear()\">{{\'LABEL_WAVER_CLEARSIGNATURE\' |translate}}</button> <button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"save()\">{{\'BUTTON_CONTINUE\' |translate}}</button><div class=\"clearfix\"></div></div>");
$templateCache.put("app/waiver/start.html","<div class=\"c-content-box c-size-xs c-bg-white\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-4 col-sm-6 wow animate fadeInLeft\" style=\"visibility: visible; animation-name: fadeInLeft; opacity: 1;\"><div class=\"c-content-step-1 c-opt-1\"><div class=\"c-icon\"><span class=\"c-hr c-hr-first\"><span class=\"c-content-line-icon fa fa-user fa-2x c-theme c-margin-t-20\"></span></span></div><div class=\"c-title c-font-20 c-font-bold c-font-uppercase\" translate=\"WAIVER_START_STEP1_HEAD\"></div><div class=\"c-description c-font-17\" translate=\"WAIVER_START_STEP1_CONTENT\"></div></div></div><div class=\"col-md-4 col-sm-6 wow animate fadeInLeft\" data-wow-delay=\"0.2s\" style=\"visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft; opacity: 1;\"><div class=\"c-content-step-1 c-opt-1\"><div class=\"c-icon\"><span class=\"c-hr\"><span class=\"c-content-line-icon fa fa-pencil fa-2x c-theme c-margin-t-20\"></span></span></div><div class=\"c-title c-font-20 c-font-bold c-font-uppercase\" translate=\"WAIVER_START_STEP2_HEAD\"></div><div class=\"c-description c-font-17\" translate=\"WAIVER_START_STEP2_CONTENT\"></div></div></div><div class=\"col-md-4 col-sm-12 wow animate fadeInLeft\" data-wow-delay=\"0.4s\" style=\"visibility: visible; animation-delay: 0.4s; animation-name: fadeInLeft; opacity: 1;\"><div class=\"c-content-step-1 c-opt-1\"><div class=\"c-icon\"><span class=\"c-hr c-hr-last\"><span class=\"c-content-line-icon fa fa-plane fa-2x c-theme c-margin-t-20\"></span></span></div><div class=\"c-title c-font-20 c-font-bold c-font-uppercase\" translate=\"WAIVER_START_STEP3_HEAD\">3. Fly</div><div class=\"c-description c-font-17\" translate=\"WAIVER_START_STEP3_CONTENT\"></div></div></div></div></div></div><div class=\"c-content-box c-size-xs c-bg-white\"><div class=\"container\"><div class=\"c-content-feedback-1 c-option-1\"><div class=\"row\" match-height=\"* { .equal-height }\"><div class=\"col-md-6\"><div class=\"c-container c-bg-grey-1 c-bg-img-bottom-right\"><div class=\"c-content-title-1\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"WAIVER_START_RESERVATION_HEADER\"></h3><div class=\"c-line-left\"></div><div class=\"equal-height\"><p class=\"c-font-lowercase equal-height\" translate=\"WAIVER_START_RESERVATION_CONTENT\"></p><br></div><div class=\"input-group input-group-lg c-square\" about=\"\"><input type=\"text\" class=\"form-control c-square\" placeholder=\"Enter your reservation id\" ng-model=\"wsc.reservationId\" ng-virtual-keyboard=\"\"> <span class=\"input-group-btn\"><button class=\"btn c-theme-btn c-btn-square c-btn-uppercase c-font-bold\" type=\"button\" ng-click=\"wsc.selectReservationId()\" translate=\"BUTTON_START\"></button></span></div><p translate=\"WAIVER_START_RESERVATION_QUESTIONS\"></p></div></div></div><div class=\"col-md-6\"><div class=\"c-container c-bg-theme c-bg-img-bottom-right\"><div class=\"c-content-title-1 c-inverse\"><h3 class=\"c-font-uppercase c-font-bold\" translate=\"WAIVER_START_NORESERVATION_HEADER\"></h3><div class=\"c-line-left\"></div><p class=\"equal-height\" translate=\"WAIVER_START_NORESERVATION_CONTENT\"></p><a ng-click=\"wsc.blankInvite()\" class=\"btn btn-md c-btn-border-2x c-btn-white c-btn-uppercase c-btn-square c-btn-bold\" translate=\"BUTTON_START\"></a><p translate=\"WAIVER_START_RESERVATION_QUESTIONS\"></p></div></div></div></div></div></div></div>");
$templateCache.put("app/waiver/waiver.html","<div class=\"c-content-box c-size-xs c-bg-white\"><div class=\"container\"><div class=\"c-content-feedback-1 c-option-1\"><div class=\"row\"><div class=\"col-md-12\"><wave-spinner ng-show=\"wc.loading\"></wave-spinner><form name=\"wc.form\" ng-hide=\"wc.loading\"><wizard on-finish=\"wc.finishWizard()\" class=\"wizard\"><wz-step wz-title=\"{{wc.fields.step1.templateOptions.label}}\" canexit=\"wc.exitValidation(wc.forms.step1.form)\" options=\"wc.options\"><formly-error-summary form=\"wc.fields.step1.form\" fields=\"wc.forms.step1.form\"></formly-error-summary><formly-form model=\"wc.model\" fields=\"wc.fields.step1.form\" form=\"wc.forms.step1.form\"><div style=\"text-align:right\"><button type=\"submit\" ng-click=\"wc.nextStep(wc.forms.step1.form)\" class=\"btn btn-primary submit-button\"><span translate=\"BUTTON_CONTINUE\"></span> <i class=\"fa fa-chevron-right\"></i></button></div></formly-form></wz-step><wz-step wz-title=\"{{wc.fields.step2.templateOptions.label}}\" canexit=\"wc.exitValidation(wc.forms.step2.form)\" options=\"wc.options\"><formly-form model=\"wc.model\" fields=\"wc.fields.step2.form\" form=\"wc.forms.step2.form\"><div style=\"text-align:right\"><button type=\"submit\" wz-cancel=\"\" class=\"btn btn-primary submit-button\" translate=\"BUTTON_BACK\"></button> <button type=\"submit\" ng-click=\"wc.nextStep(wc.forms.step2.form)\" class=\"btn btn-primary submit-button\"><span translate=\"BUTTON_CONTINUE\"></span> <i class=\"fa fa-chevron-right\"></i></button></div></formly-form></wz-step><wz-step wz-title=\"{{wc.fields.step3.templateOptions.label}}\" canexit=\"wc.exitValidation(wc.forms.step3.form)\" options=\"wc.options\" wz-disabled=\"{{!wc.showStep3}}\"><formly-form model=\"wc.model\" fields=\"wc.fields.step3.form\" form=\"wc.forms.step3.form\"><div style=\"text-align:right\"><button type=\"submit\" wz-cancel=\"\" class=\"btn btn-primary submit-button\" translate=\"BUTTON_BACK\"></button> <button type=\"submit\" ng-click=\"wc.nextStep(wc.forms.step3.form)\" class=\"btn btn-primary submit-button\"><span translate=\"BUTTON_CONTINUE\"></span> <i class=\"fa fa-chevron-right\"></i></button></div></formly-form></wz-step><wz-step wz-title=\"{{wc.fields.step4.templateOptions.label}}\" canexit=\"wc.exitValidation(wc.forms.step4.form)\" options=\"wc.options\" wz-disabled=\"{{!wc.showStep4}}\"><formly-form model=\"wc.model\" fields=\"wc.fields.step4.form\" form=\"wc.forms.step4.form\"><div style=\"text-align:right\"><button type=\"submit\" wz-cancel=\"\" class=\"btn btn-primary submit-button\" translate=\"BUTTON_BACK\"></button> <button type=\"submit\" ng-click=\"wc.nextStep(wc.forms.step4.form)\" class=\"btn btn-primary submit-button\"><span translate=\"BUTTON_CONTINUE\"></span> <i class=\"fa fa-chevron-right\"></i></button></div></formly-form></wz-step><wz-step wz-title=\"{{wc.fields.step5.templateOptions.label}}\" canexit=\"wc.exitValidation(wc.forms.step5.form)\" options=\"wc.options\" wz-disabled=\"{{!wc.showStep5}}\"><formly-form model=\"wc.model\" fields=\"wc.fields.step5.form\" form=\"wc.forms.step5.form\"><div style=\"text-align:right\"><button type=\"submit\" wz-cancel=\"\" class=\"btn btn-primary submit-button\" translate=\"BUTTON_BACK\"></button><button type=\"submit\" ng-click=\"wc.nextStep(wc.forms.step5.form)\" class=\"btn btn-primary submit-button\"><span translate=\"BUTTON_CONTINUE\"></span> <i class=\"fa fa-chevron-right\"></i></button></div></formly-form></wz-step><wz-step wz-title=\"{{wc.fields.step6.templateOptions.label}}\" canexit=\"wc.exitValidation(wc.forms.step6.form)\" options=\"wc.options\" wz-disabled=\"{{!wc.showStep6}}\"><formly-form model=\"wc.model\" fields=\"wc.fields.step6.form\" form=\"wc.forms.step6.form\"><div style=\"text-align:right\"><button type=\"submit\" wz-cancel=\"\" class=\"btn btn-primary submit-button\" translate=\"BUTTON_BACK\"></button> <button type=\"submit\" ng-disabled=\"wc.forms.step6.form.$invalid\" wz-next=\"\" class=\"btn btn-primary submit-button\"><span translate=\"BUTTON_CONTINUE\"></span> <i class=\"fa fa-chevron-right\"></i></button></div></formly-form></wz-step></wizard></form></div></div></div></div></div>");
$templateCache.put("app/components/birthday/input-birthday.template.html","<fieldset class=\"birthday-picker\"><div class=\"row\"><div class=\"col-md-4\"><select id=\"birthday-input-year\" class=\"birth-year form-control\" data-ng-model=\"$ctrl.year\" data-ng-change=\"$ctrl.update()\" data-ng-options=\"value for value in $ctrl.years\"><option value=\"\">{{ \'birthday-input.years\' | translate }}</option></select></div><div class=\"col-md-4\"><select id=\"birthday-input-month\" class=\"birth-month form-control\" data-ng-model=\"$ctrl.month\" data-ng-change=\"$ctrl.update()\" data-ng-options=\"key as value for (key, value) in $ctrl.months\"><option value=\"\">{{ \'birthday-input.months\' | translate }}</option></select></div><div class=\"col-md-4\"><select id=\"birthday-input-day\" class=\"birth-day form-control\" data-ng-if=\"$ctrl.askDay\" data-ng-model=\"$ctrl.day\" data-ng-change=\"$ctrl.update()\" data-ng-options=\"value for value in $ctrl.days\" data-ng-disabled=\"!$ctrl.month || !$ctrl.year\"><option value=\"\">{{ \'birthday-input.days\' | translate }}</option></select></div></div></fieldset>");
$templateCache.put("app/components/emailinput/email-input.template.html","<div class=\"row\"><div class=\"col-xs-5 padding-right-0\"><input type=\"text\" class=\"form-control\" ng-model=\"emailname\" ng-change=\"updateMail()\" ng-blur=\"updateMail()\"></div><div class=\"col-xs-7 padding-left-0\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">@</span> <input type=\"text\" class=\"form-control\" ng-model=\"emaildomain\" ng-change=\"updateMail()\" ng-blur=\"updateMail()\"></div></div><div class=\"error-message\" ng-show=\"hasError\">{{name |translate}}</div></div>");
$templateCache.put("app/components/gallery/gallery.html","<div class=\"ng-image-gallery img-move-dir-{{_imgMoveDirection}}\" ng-class=\"{inline:inline}\" ng-hide=\"images.length == 0\"><div class=\"ng-image-gallery-modal\" ng-if=\"opened\" ng-cloak=\"\"><div class=\"ng-image-gallery-backdrop\" ng-if=\"!inline\"></div><div class=\"ng-image-gallery-content\" ng-show=\"!imgLoading\" ng-click=\"backgroundClose($event);\"><div class=\"prev\" ng-click=\"methods.prev();\" ng-class=\"{\'bubbles-on\':bubbles}\" ng-hide=\"images.length == 1\"></div><div class=\"next\" ng-click=\"methods.next();\" ng-class=\"{\'bubbles-on\':bubbles}\" ng-hide=\"images.length == 1\"></div><div class=\"galleria\"><div class=\"galleria-images img-anim-{{imgAnim}} img-move-dir-{{_imgMoveDirection}}\"><div class=\"ws-title pull-left\" style=\"transform: translate3d(0px, 0px, 0px);\"><div class=\"photonumbercontainer pull-left\"><span class=\"photonumber\">{{_activeImg.nrOfDay}}</span></div><div class=\"pull-left\"><span class=\"ws-text\">{{_activeImg.flyerName}}</span> <span v-if=\"currentMedia\"><br>Session: {{_activeImg.startTime}}</span></div></div><div class=\"pull-left overlay-wrapper\" v-if=\"nr\"><div class=\"overlay\"><p>{{watermark}}</p></div></div><img class=\"galleria-image\" ng-right-click=\"\" ng-repeat=\"image in images track by image.id\" ng-if=\"_activeImg == image\" ng-src=\"{{image.url}}\" ondragstart=\"return false;\" ng-attr-alt=\"{{image.alt || undefined}}\"></div><div class=\"btn-group btn-group-justified\" role=\"group\"><div class=\"btn-group c-border-top\" role=\"group\"><a ui-sref=\"photo({\'activeScheduleId\':_activeImg.scheduleId})\" class=\"btn btn-lg c-btn-white c-btn-uppercase c-btn-square c-font-grey-3 c-font-white-hover c-bg-green-hover c-btn-product\"><i class=\"fa fa-arrow-left\"></i> <span translate=\"BUTTON_BACK\" class=\"ng-scope\">zurück</span></a></div><div class=\"btn-group c-border-left c-border-top\" role=\"group\"><a class=\"btn btn-lg c-btn-white c-btn-uppercase c-btn-square c-font-grey-3 c-font-white-hover c-bg-green-hover c-btn-product\" ng-click=\"_pruchaseImg(_activeImg)\"><i class=\"fa fa-shopping-cart\"></i> <span translate=\"LABEL_BUY_NOW\" class=\"ng-scope\">Jetzt kaufen</span></a></div></div><div class=\"galleria-bubbles-wrapper\" ng-if=\"bubbles && !imgBubbles\" ng-hide=\"images.length == 1\" ng-style=\"{\'height\' : bubbleSize+\'px\'}\" bubble-auto-fit=\"\"><div class=\"galleria-bubbles\" bubble-auto-scroll=\"\"><span class=\"galleria-bubble\" ng-click=\"_setActiveImg(image);\" ng-repeat=\"image in images track by image.id\" ng-class=\"{active : (_activeImg == image)}\" ng-style=\"{\'width\' : bubbleSize+\'px\', \'height\' : bubbleSize+\'px\', \'margin\': _bubbleMargin}\"></span></div></div><div class=\"galleria-bubbles-wrapper\" ng-if=\"bubbles && imgBubbles\" ng-hide=\"images.length == 1\" ng-style=\"{\'height\' : bubbleSize+\'px\'}\" bubble-auto-fit=\"\"><div class=\"galleria-bubbles\" bubble-auto-scroll=\"\"><span class=\"galleria-bubble img-bubble\" ng-click=\"_setActiveImg(image);\" ng-repeat=\"image in images track by image.id\" ng-class=\"{active : (_activeImg == image)}\" show-image-async=\"{{image.bubbleUrl || image.thumbUrl || image.url}}\" async-kind=\"bubble\" ng-style=\"{\'width\' : bubbleSize+\'px\', \'height\' : bubbleSize+\'px\', \'border-width\' : bubbleSize/10+\'px\', margin: _bubbleMargin}\"></span></div>=</div></div></div><div class=\"ng-image-gallery-loader\" ng-show=\"imgLoading\"><div class=\"spinner\"><div class=\"rect1\"></div><div class=\"rect2\"></div><div class=\"rect3\"></div><div class=\"rect4\"></div><div class=\"rect5\"></div></div></div><div class=\"ng-image-gallery-errorplaceholder\" ng-show=\"imgError\"><div class=\"ng-image-gallery-error-placeholder\" ng-bind-html=\"textValues.imageLoadErrorMsg | ngImageGalleryTrust\"></div></div></div></div>\'");}]);